webpackJsonp([1],{

/***/ "4Z/k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "62bt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "809j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8DNi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EFfJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FL5O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iyms":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KFRI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MtcT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("/5sW");

// EXTERNAL MODULE: ./node_modules/marked/lib/marked.js
var marked = __webpack_require__("EFqf");
var marked_default = /*#__PURE__*/__webpack_require__.n(marked);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LogoSquare.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LogoSquare = ({
  name: 'logoSquare',
  props: ['light']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c500f9f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LogoSquare.vue
var LogoSquare_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"512","height":"512","version":"1.1","viewBox":"0 0 135.46667 135.46666","xmlns":"http://www.w3.org/2000/svg","xmlns:cc":"http://creativecommons.org/ns#","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:rdf":"http://www.w3.org/1999/02/22-rdf-syntax-ns#"}},[_c('g',{attrs:{"transform":"translate(-29.301 -54.73)"}},[_c('g',{attrs:{"transform":"translate(146.01 178.11)","aria-label":"ア "}},[_c('path',{staticStyle:{"font-feature-settings":"normal","font-variant-caps":"normal","font-variant-ligatures":"normal","font-variant-numeric":"normal"},attrs:{"d":"m-113.88-117.13v21.773c7.3625-0.6266 12.532-1.0957 19.111-1.0957h81.615c-4.0729 7.6758-16.292 21.461-28.824 29.137l16.135 13.002c15.508-10.965 30.389-30.703 37.752-42.922 1.4098-2.3497 4.3862-6.11 6.1094-8.1465l-12.531-11.592c-2.8197 0.9399-11.436 1.4102-15.822 1.4102h-84.434c-6.5793 0-13.159-0.6265-19.111-1.5664zm45.271 32.896c0.78325 5.0128 1.0977 9.2415 1.0977 14.098 0 25.69-3.7598 42.297-23.654 56.082-5.796 4.2295-11.436 6.8921-16.449 8.6152l18.172 14.881c42.765-22.871 43.549-54.827 43.549-93.676z","fill":"#ffffff","stroke-width":".81588"}})])])])}
var staticRenderFns = []
var esExports = { render: LogoSquare_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_LogoSquare = (esExports);
// CONCATENATED MODULE: ./src/components/LogoSquare.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  LogoSquare,
  components_LogoSquare,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_LogoSquare = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/set.js
var set = __webpack_require__("lHA8");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: ./node_modules/semver/semver.js
var semver = __webpack_require__("6S2P");
var semver_default = /*#__PURE__*/__webpack_require__.n(semver);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// CONCATENATED MODULE: ./src/data/DocsSource.js








var json = function json(res) {
  if (!res.ok) throw new Error('Failed to fetch github data');
  return res.json();
};

var DocsSource_DocsSource = function () {
  function DocsSource(options) {
    classCallCheck_default()(this, DocsSource);

    this.id = options.id;
    this.name = options.name;
    this.global = options.global;
    this.repo = options.repo;
    this.defaultTag = options.defaultTag || 'master';
    this.defaultClass = options.defaultClass;
    this.defaultFile = options.defaultFile || { category: 'general', id: 'welcome' };
    this.source = options.source || 'https://github.com/' + this.repo + '/blob/';
    this.branchFilter = options.branchFilter || function (branch) {
      return branch !== 'master';
    };
    this.tagFilter = options.tagFilter || function () {
      return true;
    };
    this.tags = null;
    this.recentTag = null;
  }

  createClass_default()(DocsSource, [{
    key: 'fetchTags',
    value: function fetchTags() {
      var _this = this;

      if (this.tags) return promise_default.a.resolve(this.tags);
      return promise_default.a.all([fetch('https://api.github.com/repos/' + this.repo + '/branches').then(json), fetch('https://api.github.com/repos/' + this.repo + '/tags').then(json)]).catch(function (err) {
        if (localStorage['source-' + _this.id]) {
          console.error(err);
          var cache = JSON.parse(localStorage['source-' + _this.id]);
          return [cache.branches, cache.tags];
        }
        throw err;
      }).then(function (data) {
        var _data = slicedToArray_default()(data, 2),
            branches = _data[0],
            tags = _data[1];

        _this.tags = [_this.defaultTag];
        localStorage['source-' + _this.id] = stringify_default()({ branches: branches, tags: tags });

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(branches), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var branch = _step.value;

            if (branch.name !== _this.defaultTag && _this.branchFilter(branch.name)) _this.tags.push(branch.name);
          }

          // Build a list of the latest patch versions
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var latestPatches = {};
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(tags), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var tag = _step2.value;

            if (semver_default.a.valid(tag.name)) {
              var majorMinor = semver_default.a.major(tag.name) + '.' + semver_default.a.minor(tag.name);
              var patch = semver_default.a.patch(tag.name);
              if (patch < latestPatches[majorMinor]) continue;
              latestPatches[majorMinor] = patch;
            }
          }

          // Build the list of tags
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = get_iterator_default()(tags), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _tag = _step3.value;

            if (_tag.name === _this.defaultTag) continue;
            if (!_this.tagFilter(_tag.name)) continue;

            // Make sure the tag is the latest patch version
            if (semver_default.a.valid(_tag.name)) {
              var _majorMinor = semver_default.a.major(_tag.name) + '.' + semver_default.a.minor(_tag.name);
              var _patch = semver_default.a.patch(_tag.name);
              if (_patch < latestPatches[_majorMinor]) continue;
            }

            _this.tags.push(_tag.name);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return _this.tags;
      });
    }
  }, {
    key: 'fetchDocs',
    value: function fetchDocs(tag) {
      return fetch('https://raw.githubusercontent.com/' + this.repo + '/docs/' + tag + '.json').then(json);
    }
  }]);

  return DocsSource;
}();

/* harmony default export */ var data_DocsSource = (DocsSource_DocsSource);
// CONCATENATED MODULE: ./src/data/MainSource.js




var branchBlacklist = new set_default.a(['docs', 'parsers', 'typehandler', 'stable', '7.x']);
/* harmony default export */ var MainSource = (new data_DocsSource({
  id: 'main',
  name: 'Main library',
  global: 'Akairo',
  repo: 'discord-akairo/discord-akairo',
  defaultTag: 'master',
  defaultClass: 'AkairoClient',
  branchFilter: function branchFilter(branch) {
    return !branchBlacklist.has(branch) && !branch.startsWith('dependabot/');
  },
  tagFilter: function tagFilter(tag) {
    return semver_default.a.gte(tag, '8.0.0');
  }
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppNavbar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AppNavbar = ({
  name: 'navbar',
  props: ['repository'],
  components: {
    LogoSquare: src_components_LogoSquare
  },
  data: function data() {
    return {
      docs: {
        class: MainSource.defaultClass
      },
      tutorials: {
        category: MainSource.defaultFile.category,
        file: MainSource.defaultFile.id
      }
    };
  },

  computed: {
    tag: function tag() {
      return this.$route.params.tag || MainSource.defaultTag;
    },
    source: function source() {
      return this.$route.params.source || MainSource.id;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68823dd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppNavbar.vue
var AppNavbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('container',[_c('router-link',{attrs:{"to":"/"}},[_c('logoSquare',{attrs:{"id":"logo"}})],1),_vm._v(" "),_c('nav',[_c('router-link',{attrs:{"to":{ name: 'docs-class', params: Object.assign({}, {source: _vm.source, tag: _vm.tag}, _vm.docs) }}},[_vm._v("Reference")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'docs-file', params: Object.assign({}, {source: _vm.source, tag: _vm.tag}, _vm.tutorials) }}},[_vm._v("Guide")]),_vm._v(" "),_c('a',{attrs:{"href":("https://github.com/" + _vm.repository)}},[_vm._v("GitHub")])],1)],1)],1)}
var AppNavbar_staticRenderFns = []
var AppNavbar_esExports = { render: AppNavbar_render, staticRenderFns: AppNavbar_staticRenderFns }
/* harmony default export */ var components_AppNavbar = (AppNavbar_esExports);
// CONCATENATED MODULE: ./src/components/AppNavbar.vue
function injectStyle (ssrContext) {
  __webpack_require__("8DNi")
}
var AppNavbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppNavbar___vue_template_functional__ = false
/* styles */
var AppNavbar___vue_styles__ = injectStyle
/* scopeId */
var AppNavbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AppNavbar___vue_module_identifier__ = null
var AppNavbar_Component = AppNavbar_normalizeComponent(
  AppNavbar,
  components_AppNavbar,
  AppNavbar___vue_template_functional__,
  AppNavbar___vue_styles__,
  AppNavbar___vue_scopeId__,
  AppNavbar___vue_module_identifier__
)

/* harmony default export */ var src_components_AppNavbar = (AppNavbar_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Stats.vue





//
//
//
//
//
//
//
//

var Stats_json = function json(res) {
  return res.json();
};
var noop = function noop() {
  // Do nothing.
};
var Stats__data = {
  downloads: 'many',
  stars: 'a lot',
  contributors: 'some',
  fetching: false
};

/* harmony default export */ var Stats = ({
  name: 'stats',

  data: function data() {
    return Stats__data;
  },
  beforeMount: function beforeMount() {
    this.fetch();
  },


  methods: {
    fetch: function (_fetch) {
      function fetch() {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function () {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, _ref2, downloads, stars, contributors, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.fetching) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this.fetching = true;

                _context.next = 5;
                return promise_default.a.all([fetch('https://api.npmjs.org/downloads/range/2013-08-21:2100-08-21/discord-akairo').then(Stats_json, noop), fetch('https://api.github.com/repos/discord-akairo/discord-akairo').then(Stats_json, noop), fetch('https://api.github.com/repos/discord-akairo/discord-akairo/stats/contributors').then(Stats_json, noop)]);

              case 5:
                _ref = _context.sent;
                _ref2 = slicedToArray_default()(_ref, 3);
                downloads = _ref2[0];
                stars = _ref2[1];
                contributors = _ref2[2];

                if (!downloads) {
                  _context.next = 32;
                  break;
                }

                _this.downloads = 0;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 15;
                for (_iterator = get_iterator_default()(downloads.downloads); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  item = _step.value;
                  _this.downloads += item.downloads;
                }_context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](15);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 23:
                _context.prev = 23;
                _context.prev = 24;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 26:
                _context.prev = 26;

                if (!_didIteratorError) {
                  _context.next = 29;
                  break;
                }

                throw _iteratorError;

              case 29:
                return _context.finish(26);

              case 30:
                return _context.finish(23);

              case 31:
                _this.downloads = _this.downloads.toLocaleString();

              case 32:
                if (stars) _this.stars = stars.stargazers_count.toLocaleString();
                if (contributors) _this.contributors = contributors.length.toLocaleString();

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[15, 19, 23, 31], [24,, 26, 30]]);
      }))();
    })
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a667ff3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stats.vue
var Stats_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"stats"},[_c('li',[_vm._v(_vm._s(_vm.downloads)+" downloads")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.stars)+" stars")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.contributors)+" contributors")])])}
var Stats_staticRenderFns = []
var Stats_esExports = { render: Stats_render, staticRenderFns: Stats_staticRenderFns }
/* harmony default export */ var components_Stats = (Stats_esExports);
// CONCATENATED MODULE: ./src/components/Stats.vue
var Stats_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Stats___vue_template_functional__ = false
/* styles */
var Stats___vue_styles__ = null
/* scopeId */
var Stats___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Stats___vue_module_identifier__ = null
var Stats_Component = Stats_normalizeComponent(
  Stats,
  components_Stats,
  Stats___vue_template_functional__,
  Stats___vue_styles__,
  Stats___vue_scopeId__,
  Stats___vue_module_identifier__
)

/* harmony default export */ var src_components_Stats = (Stats_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppFooter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var AppFooter = ({
  name: 'footer',
  props: ['darkMode'],
  components: {
    Stats: src_components_Stats
  },

  methods: {
    toggleDarkMode: function toggleDarkMode(event) {
      this.$emit('toggleDarkMode');
      event.preventDefault();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eeb342a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
var AppFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('container',[_c('strong',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("discord-akairo")])],1),_vm._v(" "),_c('p',[_vm._v("A powerful and flexible bot framework for discord.js")]),_vm._v(" "),_c('p',[_vm._v("Website originally created by the "),_c('a',{attrs:{"href":"https://github.com/discordjs/website"}},[_vm._v("discord.js")]),_vm._v(" team")]),_vm._v(" "),_c('stats'),_vm._v(" "),_c('a',{attrs:{"href":"","id":"dark-mode-link"},on:{"click":_vm.toggleDarkMode}},[_c('em',{staticClass:"fa",class:_vm.darkMode ? 'fa-sun-o' : 'fa-moon-o'}),_vm._v("\n      Turn "+_vm._s(_vm.darkMode ? 'on' : 'off')+" the lights\n    ")])],1)],1)}
var AppFooter_staticRenderFns = []
var AppFooter_esExports = { render: AppFooter_render, staticRenderFns: AppFooter_staticRenderFns }
/* harmony default export */ var components_AppFooter = (AppFooter_esExports);
// CONCATENATED MODULE: ./src/components/AppFooter.vue
function AppFooter_injectStyle (ssrContext) {
  __webpack_require__("XV0z")
}
var AppFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppFooter___vue_template_functional__ = false
/* styles */
var AppFooter___vue_styles__ = AppFooter_injectStyle
/* scopeId */
var AppFooter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AppFooter___vue_module_identifier__ = null
var AppFooter_Component = AppFooter_normalizeComponent(
  AppFooter,
  components_AppFooter,
  AppFooter___vue_template_functional__,
  AppFooter___vue_styles__,
  AppFooter___vue_scopeId__,
  AppFooter___vue_module_identifier__
)

/* harmony default export */ var src_components_AppFooter = (AppFooter_Component.exports);

// EXTERNAL MODULE: ./node_modules/konami-code-js/src/konami-code.js
var konami_code = __webpack_require__("7ljE");
var konami_code_default = /*#__PURE__*/__webpack_require__.n(konami_code);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//






var konami = null;

/* harmony default export */ var App = ({
  name: 'app',
  components: {
    AppNavbar: src_components_AppNavbar,
    AppFooter: src_components_AppFooter
  },

  data: function data() {
    var darkMode = localStorage.getItem('dark-mode');
    return {
      darkMode: darkMode !== 'false' && darkMode !== null,
      repository: MainSource.repo,
      konami: false
    };
  },


  methods: {
    toggleDarkMode: function toggleDarkMode() {
      this.darkMode = !this.darkMode;
      localStorage.setItem('dark-mode', this.darkMode);
      if (this.darkMode) this.$el.classList.add('dark');else this.$el.classList.remove('dark');
    },
    setRepository: function setRepository(repo) {
      this.repository = repo;
    },
    poop: function poop() {
      var _this = this;

      // Create the poop
      var poop = document.createElement('div');
      poop.className = 'poop';
      poop.innerHTML = '💩';

      // Set the poop's travel time and how spinny it is
      var duration = Math.random() * 4000 + 1000;
      poop.style.transition = 'top ' + duration + 'ms linear, left ' + duration + 'ms linear';
      poop.style.animation = 'spin ' + duration / 3000 + 's infinite linear';

      // Determine the poop's initial location and final destination
      var side = Math.floor(Math.random() * 4) + 1;
      var initial = {
        top: (side === 2 || side === 4 ? Math.random() * window.innerHeight : side === 1 ? -200 : window.innerHeight + 200) + 'px',
        left: (side === 1 || side === 3 ? Math.random() * window.innerWidth : side === 4 ? -200 : window.innerWidth + 200) + 'px'
      };
      var final = {
        top: (side === 2 || side === 4 ? Math.random() * window.innerHeight : side === 1 ? window.innerHeight + 200 : -200) + 'px',
        left: (side === 1 || side === 3 ? Math.random() * window.innerWidth : side === 4 ? window.innerWidth + 200 : -200) + 'px'
      };

      // Pinpoint and relocate the poop
      assign_default()(poop.style, initial);
      window.setTimeout(function () {
        assign_default()(poop.style, final);
      }, 100);

      // Add the poop to the page and remove it when its adventure is complete
      document.body.appendChild(poop);
      window.setTimeout(function () {
        document.body.removeChild(poop);
      }, duration + 100);

      // Take another dump
      window.setTimeout(function () {
        return _this.poop();
      }, Math.random() * 10000 + 1000);
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    if (this.darkMode) this.$el.classList.add('dark');
    if (!konami) {
      konami = new konami_code_default.a(function () {
        _this2.konami = true;
        _this2.poop();
        konami.disable();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745107e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-navbar',{attrs:{"repository":_vm.repository}}),_vm._v(" "),_c('router-view',{attrs:{"darkMode":_vm.darkMode,"konami":_vm.konami},on:{"toggleDarkMode":_vm.toggleDarkMode,"setRepository":_vm.setRepository}}),_vm._v(" "),_c('app-footer',{attrs:{"darkMode":_vm.darkMode},on:{"toggleDarkMode":_vm.toggleDarkMode}})],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("KFRI")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Logo.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var Logo = ({
  name: 'logo',
  props: ['light', 'konami']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79a521e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
var Logo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1500","height":"350","version":"1.1","viewBox":"0 0 396.87499 92.604164","xmlns":"http://www.w3.org/2000/svg","xmlns:cc":"http://creativecommons.org/ns#","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:rdf":"http://www.w3.org/1999/02/22-rdf-syntax-ns#"}},[_c('g',{attrs:{"transform":"translate(552.69 25.689)"}},[_c('path',{attrs:{"transform":"translate(-725.68 78.726)","d":"m174.51-101.97v14.99c5.0688-0.43139 8.6267-0.75391 13.156-0.75391h56.189c-2.804 5.2845-11.216 14.774-19.844 20.059l11.107 8.9531c10.677-7.5493 20.921-21.139 25.99-29.551 0.97063-1.6177 3.0207-4.2074 4.207-5.6094l-8.627-7.9805c-1.9412 0.64709-7.8728 0.97071-10.893 0.97071h-58.131c-4.5296 0-9.058-0.43104-13.156-1.0781zm183.12 0.53125-13.164 3.1602v77.41h13.164v-18.852l6.3203-6.6895 16.588 25.541h15.639l-22.959-35.02 19.062-21.379h-15.85l-18.801 21.643zm105.41 2.3184c-2.1064 0-3.9142 0.75409-5.4238 2.2637-1.4745 1.4745-2.2109 3.2647-2.2109 5.3711s0.73646 3.9142 2.2109 5.4238c1.5096 1.4745 3.3174 2.2129 5.4238 2.2129 2.1064 0 3.8986-0.73841 5.373-2.2129 1.5096-1.5096 2.2637-3.3174 2.2637-5.4238s-0.7541-3.8966-2.2637-5.3711c-1.4745-1.5096-3.2666-2.2637-5.373-2.2637zm-161.85 0.05273-30.752 78.199h15.219l5.3711-15.641h26.436l5.6328 15.641h15.113l-31.016-78.199zm-95.508 19.746c0.53923 3.4511 0.75391 6.3638 0.75391 9.707 0 17.687-2.5885 29.119-16.285 38.609-3.9904 2.9119-7.8731 4.7434-11.324 5.9297l12.512 10.246c29.442-15.746 29.98-37.746 29.98-64.492zm216.35 1.002c-6.249 0-11.637 1.0871-16.166 3.2637l2.8438 10.217c3.3351-1.65 7.4777-2.4746 12.428-2.4746 8.3905 0 12.586 3.316 12.586 9.9512-2.1064-0.5266-3.9319-0.78906-5.4766-0.78906-9.0224 0-15.991 1.8431-20.906 5.5293-4.8798 3.6862-7.3203 8.7944-7.3203 15.324 1e-5 5.5819 1.7374 9.9008 5.2129 12.955 3.4756 3.0192 8.2508 4.5273 14.324 4.5273 3.2298-2e-6 6.3186-0.61307 9.2676-1.8418 2.9841-1.2638 5.074-2.8797 6.2676-4.8457 0.5266 1.65 1.5432 3.1778 3.0527 4.582 1.5096 1.4043 3.2136 2.1055 5.1094 2.1055 1.7202 0 3.246-0.22721 4.5801-0.68359 1.334-0.42128 2.5465-1.5808 3.6348-3.4766-3.0192-1.9309-4.5293-6.6532-4.5293-14.166v-12.059c0-10.918-2.0018-18.326-6.0039-22.223-4.0022-3.9319-10.303-5.8965-18.904-5.8965zm84.402 0c-6.1085 0-11.005 2.0703-14.691 6.2129v-5.1602h-13.164v56.398h13.164v-32.123c0-4.0021 1.1772-7.3887 3.5293-10.162 2.3872-2.7734 5.1078-4.1602 8.1621-4.1602 2.8085 0 5.3881 0.77172 7.7402 2.3164l5.582-11.27c-2.3872-1.3692-5.8286-2.0527-10.322-2.0527zm34.277 0c-8.1447 0-14.71 2.703-19.695 8.1094-4.95 5.4064-7.4238 12.411-7.4238 21.012 0 8.882 2.368 16.008 7.1074 21.379 4.7745 5.3362 11.446 8.0039 20.012 8.0039 8.3905-2e-6 14.991-2.6501 19.801-7.9512 4.8447-5.3011 7.2656-12.444 7.2656-21.432 0-9.0224-2.37-16.132-7.1094-21.328-4.7394-5.1958-11.391-7.793-19.957-7.793zm-91.678 1.0527v10.795h7.2129v45.604h13.324v-56.398zm-144.84 1.791 9.2676 28.488h-18.535zm236.52 7.8984c8.9171 0 13.375 6.1267 13.375 18.379 0 5.9681-1.2105 10.567-3.6328 13.797-2.3872 3.2298-5.6347 4.8438-9.7422 4.8438-8.9522 0-13.428-6.2129-13.428-18.641 0-5.7926 1.2105-10.305 3.6328-13.535s5.6874-4.8438 9.7949-4.8438zm-111.94 19.484c1.1234 0 2.8098 0.22721 5.0566 0.68359v5.2656c0 7.899-3.9506 11.85-11.85 11.85-5.8628 0-8.793-2.5286-8.793-7.584 0-6.8107 5.1944-10.215 15.586-10.215z","fill":"#ffffff"}})])])}
var Logo_staticRenderFns = []
var Logo_esExports = { render: Logo_render, staticRenderFns: Logo_staticRenderFns }
/* harmony default export */ var components_Logo = (Logo_esExports);
// CONCATENATED MODULE: ./src/components/Logo.vue
var Logo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Logo___vue_template_functional__ = false
/* styles */
var Logo___vue_styles__ = null
/* scopeId */
var Logo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Logo___vue_module_identifier__ = null
var Logo_Component = Logo_normalizeComponent(
  Logo,
  components_Logo,
  Logo___vue_template_functional__,
  Logo___vue_styles__,
  Logo___vue_scopeId__,
  Logo___vue_module_identifier__
)

/* harmony default export */ var src_components_Logo = (Logo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Home = ({
  name: 'home',
  props: ['konami'],
  components: {
    Logo: src_components_Logo
  },

  mounted: function mounted() {
    this.$emit('setRepository', MainSource.repo);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dd9003f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('slide',{attrs:{"id":"jumbotron"}},[_c('logo',{attrs:{"light":true,"konami":_vm.konami,"id":"logo"}}),_vm._v(" "),_c('code',[_vm._v("npm install discord-akairo")]),_c('br')],1),_vm._v(" "),_c('section',{attrs:{"id":"info"}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"full-info-item"},[_c('router-link',{staticClass:"big-ass-btn",attrs:{"to":"/docs"}},[_vm._v("Get started")]),_vm._v(" "),_c('a',{staticClass:"big-ass-btn discord",attrs:{"href":"https://discord.gg/arTauDY"}},[_vm._v("Discord")])],1)])],1)}
var Home_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-item"},[_c('h2',[_vm._v("About")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("discord-akairo")]),_vm._v(" is a powerful and flexible bot framework for "),_c('a',{attrs:{"href":"https://discord.js.org/"}},[_vm._v("discord.js")]),_vm._v(".\n        It allows bot creators absolute freedom in their creativity while taking care of the boilerplate and dirty work.\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-item"},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("Modular and reloadable commands, inhibitors, and listeners.")]),_vm._v(" "),_c('li',[_vm._v("Flexible command handling and creation.")]),_vm._v(" "),_c('li',[_vm._v("Powerful and thorough command arguments parsing.")]),_vm._v(" "),_c('li',[_vm._v("Message monitoring and blocking with inhibitors.")]),_vm._v(" "),_c('li',[_vm._v("Informative events during command handling.")]),_vm._v(" "),_c('li',[_vm._v("And many other useful utilities.")])])])])}]
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var pages_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/pages/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("4Z/k")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  pages_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var components_pages_Home = (Home_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/url/url.js
var url_url = __webpack_require__("UZ5h");
var url_default = /*#__PURE__*/__webpack_require__.n(url_url);

// CONCATENATED MODULE: ./src/util.js



// Highlights an element with highlight.js, delaying until it's loaded
function hljs(el) {
  if (window.hljs) {
    window.hljs.highlightBlock(el);
  } else {
    var attempts = 0;
    var interval = setInterval(function () {
      if (window.hljs) {
        window.hljs.highlightBlock(el);
        clearInterval(interval);
      } else {
        attempts++;
        if (attempts >= 50) clearInterval(interval);
      }
    }, 100);
  }
}

// Creates a full URL for a GitHub source view
function util_sourceURL(url, tag, path, file, line) {
  return Object(url_url["resolve"])(url, tag + '/' + path + (file ? '/' + file : '') + (line ? '#L' + line : ''));
}

// Converts a JSDoc link value to an object of link information
function parseLink(link, docs) {
  var matches = link.match(/\{@link\s+(.+?)(?:\s+(.+?))?\s*\}/i);
  if (matches) link = matches[1];
  var text = matches ? matches[2] : null;

  // Type link
  var split = link.split(/(\.|#)/);
  if (docs.links[split[0]]) {
    return {
      text: text || link,
      link: typeof_default()(docs.links[split[0]]) === 'object' ? {
        name: docs.links[split[0]].name,
        params: docs.links[split[0]].params,
        query: { scrollTo: split[1] ? '' + (split[1] === '.' ? 's-' : '') + split[2] : undefined }
      } : docs.links[split[0]]
    };
  }

  // Any link
  if (link.match(/^https?:\/\//i)) {
    return {
      text: text || link,
      link: link
    };
  }

  // Plain text
  return { text: text || link };
}

// Converts all JSDoc links to markdown links
function convertLinks(text, docs, router, route) {
  if (!text) return null;

  var regex = /\{@link\s+(.+?)(?:\s+(.+?))?\s*\}/gi;
  var match = void 0;
  var newText = '';
  var start = 0;

  while (match = regex.exec(text)) {
    // eslint-disable-line no-cond-assign
    newText += text.slice(start, match.index);

    var parsed = parseLink(match[0], docs);
    if (parsed.link) {
      var link = void 0;
      if (typeof_default()(parsed.link) === 'object') {
        if (!parsed.link.params) parsed.link.params = {};
        parsed.link.params.source = route.params.source;
        parsed.link.params.tag = route.params.tag;
        link = router.resolve(parsed.link).href;
      } else {
        link = parsed.link;
      }
      newText += '[' + parsed.text + '](' + link + ')';
    } else {
      newText += parsed.text;
    }

    start = match.index + match[0].length;
  }

  if (newText) {
    newText += text.slice(start);
    return newText;
  }

  return text;
}

// Prefixes a doc item's name with "s-" if static
function scopedName(item) {
  return '' + (item.scope === 'static' ? 's-' : '') + item.name;
}

// Makes a key for a types array/string
function typeKey(type) {
  return typeof type === 'string' ? type : type.join('-');
}

// Stupid Holder to Improve Tag Switching
var SHITS = { switching: false };
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/Navbar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Navbar = ({
  name: 'docs-navbar',
  props: ['sources', 'source'],

  data: function data() {
    return {
      sourceChoice: this.source.id,
      tagChoice: null,
      tags: null,
      search: this.$route.query.q
    };
  },


  methods: {
    loadTags: function loadTags() {
      var _this = this;

      this.tags = this.source.tags;
      if (!this.tags) {
        var startSource = this.source;
        this.source.fetchTags().then(function (tags) {
          if (_this.source.id === startSource.id) _this.tags = tags;
        });
      }
    },
    updateTagChoice: function updateTagChoice() {
      if (this.tags) this.tagChoice = this.$route.params.tag || this.source.recentTag || this.source.defaultTag;
    },
    goToSearch: function goToSearch() {
      if (this.$route.name !== 'docs-search') this.$router.push({ name: 'docs-search', query: { q: this.search } });
    }
  },

  watch: {
    sourceChoice: function sourceChoice(src) {
      if (this.$route.params.source !== src) this.$router.push({ name: 'docs-source', params: { source: src } });
    },
    tagChoice: function tagChoice(tag) {
      if (tag && this.$route.params.tag !== tag) {
        SHITS.switching = true;
        this.$router.push({ name: this.$route.name, params: extends_default()({}, this.$route.params, { tag: tag }), query: this.$route.query });
      }
    },
    source: function source(_source) {
      this.sourceChoice = _source.id;
      this.tagChoice = null;
      this.loadTags();
    },
    search: function search(q) {
      if (this.$route.query.q) this.$router.replace({ name: 'docs-search', query: { q: q } });else this.$router.push({ name: 'docs-search', query: { q: q } });
    },
    $route: function $route(to) {
      if (this.tagChoice && to.params.tag && this.tagChoice !== to.params.tag) this.tagChoice = to.params.tag;
    }
  },

  created: function created() {
    this.loadTags();
  },
  mounted: function mounted() {
    this.updateTagChoice();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-483ace6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/Navbar.vue
var Navbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"docs-navbar"}},[_c('container',[_vm._v("\n    View docs for\n\n    "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sourceChoice),expression:"sourceChoice"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sourceChoice=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.sources),function(source){return _c('option',{domProps:{"value":source.id}},[_vm._v(_vm._s(source.name))])}),0),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"},on:{"enter":_vm.updateTagChoice}},[(_vm.tags)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tagChoice),expression:"tagChoice"}],key:_vm.source.id,on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tagChoice=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.tags),function(tag){return _c('option',{domProps:{"value":tag}},[_vm._v(_vm._s(tag))])}),0):_c('loading')],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.search),expression:"search",modifiers:{"trim":true}}],attrs:{"type":"search","placeholder":"Search"},domProps:{"value":(_vm.search)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.goToSearch($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'docs-search' }}},[_c('em',{staticClass:"fa fa-search"})])],1)],1)}
var Navbar_staticRenderFns = []
var Navbar_esExports = { render: Navbar_render, staticRenderFns: Navbar_staticRenderFns }
/* harmony default export */ var docs_Navbar = (Navbar_esExports);
// CONCATENATED MODULE: ./src/components/docs/Navbar.vue
function Navbar_injectStyle (ssrContext) {
  __webpack_require__("EFfJ")
}
var Navbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Navbar___vue_template_functional__ = false
/* styles */
var Navbar___vue_styles__ = Navbar_injectStyle
/* scopeId */
var Navbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Navbar___vue_module_identifier__ = null
var Navbar_Component = Navbar_normalizeComponent(
  Navbar,
  docs_Navbar,
  Navbar___vue_template_functional__,
  Navbar___vue_styles__,
  Navbar___vue_scopeId__,
  Navbar___vue_module_identifier__
)

/* harmony default export */ var components_docs_Navbar = (Navbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Documentation.vue

//
//
//
//
//
//
//




/* harmony default export */ var Documentation = ({
  name: 'documentation',
  props: ['darkMode'],
  components: {
    DocsNavbar: components_docs_Navbar
  },

  data: function data() {
    return {
      sources: defineProperty_default()({}, MainSource.id, MainSource),
      source: MainSource,
      tag: MainSource.defaultTag
    };
  },


  methods: {
    setSource: function setSource(id) {
      this.source = this.sources[id];
    },
    setTag: function setTag(tag) {
      this.tag = tag;
      this.source.recentTag = tag;
    },
    handleRoute: function handleRoute(route) {
      // Set the source, or redirect to a default route
      if (route.params.source && this.sources[route.params.source]) {
        this.setSource(route.params.source);
      } else {
        this.$router.replace({ name: 'docs-class', params: {
            source: MainSource.id,
            tag: MainSource.defaultTag,
            class: MainSource.defaultClass
          } });
        return;
      }

      // Set the tag, or redirect to a default route
      if (route.params.tag) {
        this.setTag(route.params.tag);
      } else {
        this.$router.replace({ name: 'docs-file', params: {
            source: this.source.id,
            tag: this.source.recentTag || this.source.defaultTag,
            category: this.source.defaultFile.category,
            file: this.source.defaultFile.id
          } });
        return;
      }

      // Redirect to a default route
      if (!route.params.file && !route.params.class && !route.params.typedef && route.name !== 'docs-search') {
        this.$router.replace({ name: 'docs-file', params: {
            source: this.source.id,
            tag: this.tag,
            category: this.source.defaultFile.category,
            file: this.source.defaultFile.id
          } });
      }
    },
    toggleDarkMode: function toggleDarkMode() {
      this.$emit('toggleDarkMode');
    },
    setRepository: function setRepository(repo) {
      this.$emit('setRepository', repo);
    }
  },

  watch: {
    $route: function $route(to) {
      this.handleRoute(to);
    }
  },

  created: function created() {
    this.handleRoute(this.$route);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e064624","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Documentation.vue
var Documentation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"docs"}},[_c('docs-navbar',{attrs:{"sources":_vm.sources,"source":_vm.source}}),_vm._v(" "),_c('router-view',{attrs:{"source":_vm.source,"tag":_vm.tag,"darkMode":_vm.darkMode},on:{"toggleDarkMode":_vm.toggleDarkMode,"setRepository":_vm.setRepository}})],1)}
var Documentation_staticRenderFns = []
var Documentation_esExports = { render: Documentation_render, staticRenderFns: Documentation_staticRenderFns }
/* harmony default export */ var pages_Documentation = (Documentation_esExports);
// CONCATENATED MODULE: ./src/components/pages/Documentation.vue
var Documentation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Documentation___vue_template_functional__ = false
/* styles */
var Documentation___vue_styles__ = null
/* scopeId */
var Documentation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Documentation___vue_module_identifier__ = null
var Documentation_Component = Documentation_normalizeComponent(
  Documentation,
  pages_Documentation,
  Documentation___vue_template_functional__,
  Documentation___vue_styles__,
  Documentation___vue_scopeId__,
  Documentation___vue_module_identifier__
)

/* harmony default export */ var components_pages_Documentation = (Documentation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/UnknownRoute.vue
//
//
//
//
//
//

/* harmony default export */ var UnknownRoute = ({
  name: 'unknown-route',
  props: ['darkMode']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53f93612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/UnknownRoute.vue
var UnknownRoute_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slide',{attrs:{"id":"unknown-route"}},[_c('unknown-page',{attrs:{"type":"route","darkMode":_vm.darkMode}})],1)}
var UnknownRoute_staticRenderFns = []
var UnknownRoute_esExports = { render: UnknownRoute_render, staticRenderFns: UnknownRoute_staticRenderFns }
/* harmony default export */ var pages_UnknownRoute = (UnknownRoute_esExports);
// CONCATENATED MODULE: ./src/components/pages/UnknownRoute.vue
function UnknownRoute_injectStyle (ssrContext) {
  __webpack_require__("ZDZm")
}
var UnknownRoute_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UnknownRoute___vue_template_functional__ = false
/* styles */
var UnknownRoute___vue_styles__ = UnknownRoute_injectStyle
/* scopeId */
var UnknownRoute___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UnknownRoute___vue_module_identifier__ = null
var UnknownRoute_Component = UnknownRoute_normalizeComponent(
  UnknownRoute,
  pages_UnknownRoute,
  UnknownRoute___vue_template_functional__,
  UnknownRoute___vue_styles__,
  UnknownRoute___vue_scopeId__,
  UnknownRoute___vue_module_identifier__
)

/* harmony default export */ var components_pages_UnknownRoute = (UnknownRoute_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/Loader.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Loader = ({
  name: 'docs-loader',
  props: ['source', 'tag', 'darkMode'],

  data: function data() {
    return {
      docs: null,
      error: null,
      loadingTag: null
    };
  },


  methods: {
    loadDocs: function loadDocs() {
      var _this = this;

      if (this.loadingTag === this.tag) return;
      this.docs = null;
      this.error = null;

      var startSource = this.source;
      var startTag = this.tag;
      this.loadingTag = this.tag;
      this.setRepository(this.source.repo);

      this.source.fetchDocs(this.tag).then(function (docs) {
        // eslint-disable-line complexity
        if (_this.source !== startSource || _this.tag !== startTag) return;
        console.log('Loading', startSource, startTag);

        // Sort everything
        docs.classes.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        docs.typedefs.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(docs.classes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var c = _step.value;

            if (c.props) c.props.sort(function (a, b) {
              return a.name.localeCompare(b.name);
            });
            if (c.methods) c.methods.sort(function (a, b) {
              return a.name.localeCompare(b.name);
            });
            if (c.events) c.events.sort(function (a, b) {
              return a.name.localeCompare(b.name);
            });
          }

          // Built-in type links
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        docs.links = {
          string: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String',
          number: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number',
          boolean: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Boolean',
          symbol: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol',
          void: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/undefined',
          Object: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object',
          Function: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function',
          function: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function',
          Array: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array',
          Set: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set',
          Map: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map',
          Date: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date',
          RegExp: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp',
          Promise: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise',
          Error: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error',
          EventEmitter: 'https://nodejs.org/dist/latest/docs/api/events.html#events_class_eventemitter',
          Timeout: 'https://nodejs.org/dist/latest/docs/api/timers.html#timers_class_timeout',
          Buffer: 'https://nodejs.org/dist/latest/docs/api/buffer.html#buffer_class_buffer',
          ReadableStream: 'https://nodejs.org/dist/latest/docs/api/stream.html#stream_class_stream_readable',
          ChildProcess: 'https://nodejs.org/dist/latest/docs/api/child_process.html#child_process_class_childprocess',
          Worker: 'https://nodejs.org/api/worker_threads.html#worker_threads_class_worker',
          MessagePort: 'https://nodejs.org/api/worker_threads.html#worker_threads_class_messageport'
        };

        // Add links for everything
        docs.externals = docs.externals || [];
        docs.classes = docs.classes || [];
        docs.typedefs = docs.typedefs || [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(docs.externals), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var x = _step2.value;
            docs.links[x.name] = x.see[0].replace(/\{@link\s+(.+?)\s*\}/i, '$1');
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = get_iterator_default()(docs.classes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _c = _step3.value;
            docs.links[_c.name] = { name: 'docs-class', params: { class: _c.name } };
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = get_iterator_default()(docs.typedefs), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var t = _step4.value;
            docs.links[t.name] = { name: 'docs-typedef', params: { typedef: t.name } };
          } // Workaround for the single use of inter-source see also linking
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        if (_this.source.id === 'commando') {
          docs.links.Message = { name: 'docs-class', params: { source: 'main', tag: 'master', class: 'Message' } };
        }

        docs.global = _this.source.global;
        docs.source = _this.source.source;
        docs.tag = _this.tag;
        _this.docs = docs;
        _this.loadingTag = null;
        console.log('Finished loading', startSource, startTag);

        // Verify the destination item exists when switching tags
        if (SHITS.switching) {
          var route = _this.$route;
          SHITS.switching = false;
          if (route.name === 'docs-class') {
            if (!docs.classes.some(function (c) {
              return c.name === route.params.class;
            })) _this.goHome();
          } else if (route.name === 'docs-typedef') {
            if (!docs.typedefs.some(function (t) {
              return t.name === route.params.typedef;
            })) _this.goHome();
          } else if (route.name === 'docs-file') {
            if (!docs.custom[route.params.category] || !docs.custom[route.params.category].files[route.params.file]) {
              _this.goHome();
            }
          }
        }
      }).catch(function (err) {
        console.error('Error while loading', startSource, startTag, err);
        _this.error = err;
        _this.loadingTag = null;
      });
    },
    scroll: function scroll(fromRoute) {
      var _this2 = this;

      if (this.$route.query.scrollTo && this.docs) {
        var scroll = function scroll() {
          var el = document.getElementById('doc-for-' + _this2.$route.query.scrollTo);
          // For backwards-compatibility of old event URLs
          if (!el) el = document.getElementById('doc-for-e-' + _this2.$route.query.scrollTo);
          if (!el) el = document.getElementById(_this2.$route.query.scrollTo);
          if (!el) return;
          el.setAttribute('data-scrolled', true);
          setTimeout(function () {
            return el.setAttribute('data-scrolled', false);
          }, 1000);
          setTimeout(function () {
            return el.removeAttribute('data-scrolled');
          }, 2000);
          el.scrollIntoView();
          window.scrollBy(0, -50);
        };

        var delayScroll = fromRoute && (this.$route.name !== fromRoute.name || this.$route.params.class !== fromRoute.params.class || this.$route.params.typedef !== fromRoute.params.typedef || this.$route.params.file !== fromRoute.params.file);
        if (delayScroll) setTimeout(scroll, 400);else scroll();
      }
    },
    goHome: function goHome() {
      console.log('Redirecting to default file due to the current page not existing in the newly-loaded tag\'s docs.');
      this.$router.replace({ name: 'docs-file', params: {
          source: this.source.id,
          tag: this.tag,
          category: this.source.defaultFile.category,
          file: this.source.defaultFile.id
        } });
    },
    toggleDarkMode: function toggleDarkMode() {
      this.$emit('toggleDarkMode');
    },
    setRepository: function setRepository(repo) {
      this.$emit('setRepository', repo);
    }
  },

  watch: {
    source: function source() {
      this.loadDocs();
    },
    tag: function tag() {
      this.loadDocs();
    },
    docs: function docs(to, from) {
      if (!from) setTimeout(this.scroll, 700);
    },
    $route: function $route(to, from) {
      this.scroll(from);
    }
  },

  created: function created() {
    this.loadDocs();
  },
  mounted: function mounted() {
    this.$nextTick(this.scroll);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb2a32f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/Loader.vue
var Loader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"docs-body"}},[_c('transition',{attrs:{"name":"fade-resize","mode":"out-in"}},[(_vm.docs)?_c('router-view',{attrs:{"docs":_vm.docs,"darkMode":_vm.darkMode},on:{"toggleDarkMode":_vm.toggleDarkMode,"setRepository":_vm.setRepository}}):_c('slide',[(!_vm.error)?_c('loading'):_c('p',{attrs:{"id":"docs-error"}},[_vm._v("\n        Couldn't load the documentation data.\n        "),_c('pre',[_vm._v(_vm._s(_vm.error.toString()))])])],1)],1)],1)}
var Loader_staticRenderFns = []
var Loader_esExports = { render: Loader_render, staticRenderFns: Loader_staticRenderFns }
/* harmony default export */ var docs_Loader = (Loader_esExports);
// CONCATENATED MODULE: ./src/components/docs/Loader.vue
function Loader_injectStyle (ssrContext) {
  __webpack_require__("zMz9")
}
var Loader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Loader___vue_template_functional__ = false
/* styles */
var Loader___vue_styles__ = Loader_injectStyle
/* scopeId */
var Loader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Loader___vue_module_identifier__ = null
var Loader_Component = Loader_normalizeComponent(
  Loader,
  docs_Loader,
  Loader___vue_template_functional__,
  Loader___vue_styles__,
  Loader___vue_scopeId__,
  Loader___vue_module_identifier__
)

/* harmony default export */ var components_docs_Loader = (Loader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/Sidebar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Sidebar = ({
  name: 'docs-sidebar',
  props: ['docs', 'darkMode'],

  data: function data() {
    return {
      visible: false,
      showPrivate: false
    };
  },


  computed: {
    showTutorialsSidebar: function showTutorialsSidebar() {
      // eslint-disable-next-line eqeqeq
      return this.$route.params.category != null;
    },
    togglePrivateLabel: function togglePrivateLabel() {
      return 'Private items are ' + (this.showPrivate ? 'shown' : 'hidden') + '. Click to toggle.';
    },
    toggleDarkModeLabel: function toggleDarkModeLabel() {
      return 'The lights are ' + (this.darkMode ? 'off' : 'on') + '. Click to toggle.';
    }
  },

  methods: {
    toggle: function toggle() {
      this.visible = !this.visible;
    },
    togglePrivate: function togglePrivate() {
      this.showPrivate = !this.showPrivate;
    },
    toggleDarkMode: function toggleDarkMode() {
      this.$emit('toggleDarkMode');
    }
  },

  watch: {
    showPrivate: function showPrivate(to) {
      this.$emit('showPrivate', to);
    },
    $route: function $route(to) {
      if (this.visible) this.visible = false;
      if (!to.query.scrollTo && (window.pageYOffset || document.documentElement.scrollTop) > 300) {
        window.scrollTo(0, 90);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70fc1e78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/Sidebar.vue
var Sidebar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"docs-sidebar"}},[_c('div',{attrs:{"id":"open-btn"},on:{"click":_vm.toggle}},[_c('em',{staticClass:"fa fa-bars"})]),_vm._v(" "),_c('div',{class:_vm.visible ? 'open' : 'closed',attrs:{"id":"docs-sidebar-content"}},[_c('div',{attrs:{"id":"close-btn"},on:{"click":_vm.toggle}},[_c('em',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),(_vm.showTutorialsSidebar)?void 0:_c('em',{staticClass:"fa toggle",class:_vm.showPrivate ? 'fa-eye' : 'fa-eye-slash',attrs:{"id":"docs-visibility","title":_vm.togglePrivateLabel},on:{"click":_vm.togglePrivate}}),_vm._v(" "),_c('em',{staticClass:"fa toggle",class:_vm.darkMode ? 'fa-moon-o' : 'fa-sun-o',attrs:{"id":"docs-brightness","title":_vm.toggleDarkModeLabel},on:{"click":_vm.toggleDarkMode}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade-slide","mode":"out-in"}},[(_vm.showTutorialsSidebar)?_c('ul',_vm._l((_vm.docs.custom),function(category,categoryID){return _c('li',{key:categoryID},[_vm._v("\n          "+_vm._s(category.name)+"\n          "),_c('ul',_vm._l((category.files),function(file,fileID){return _c('li',{key:fileID},[_c('router-link',{attrs:{"to":{ name: 'docs-file', params: { category: categoryID, file: fileID } }}},[_vm._v("\n                "+_vm._s(file.name)+"\n              ")])],1)}),0)])}),0):_c('ul',{key:"docs-sidebar"},[_c('li',[_vm._v("\n          Classes\n          "),_c('transition-group',{attrs:{"name":"animated-list","tag":"ul"}},_vm._l((_vm.docs.classes),function(clarse){return (_vm.showPrivate || clarse.access !== 'private')?_c('li',{key:clarse.name,staticClass:"animated-list-item"},[_c('router-link',{attrs:{"exact":"","to":{ name: 'docs-class', params: { class: clarse.name } }}},[_vm._v("\n                "+_vm._s(clarse.name)+"\n              ")])],1):_vm._e()}),0)],1),_vm._v(" "),_c('li',[_vm._v("\n          Typedefs\n          "),_c('transition-group',{attrs:{"name":"animated-list","tag":"ul"}},_vm._l((_vm.docs.typedefs),function(typedef){return (_vm.showPrivate || typedef.access !== 'private')?_c('li',{key:typedef.name,staticClass:"animated-list-item"},[_c('router-link',{attrs:{"exact":"","to":{ name: 'docs-typedef', params: { typedef: typedef.name } }}},[_vm._v("\n                "+_vm._s(typedef.name)+"\n              ")])],1):_vm._e()}),0)],1)])])],2)])}
var Sidebar_staticRenderFns = []
var Sidebar_esExports = { render: Sidebar_render, staticRenderFns: Sidebar_staticRenderFns }
/* harmony default export */ var docs_Sidebar = (Sidebar_esExports);
// CONCATENATED MODULE: ./src/components/docs/Sidebar.vue
function Sidebar_injectStyle (ssrContext) {
  __webpack_require__("t5H2")
}
var Sidebar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Sidebar___vue_template_functional__ = false
/* styles */
var Sidebar___vue_styles__ = Sidebar_injectStyle
/* scopeId */
var Sidebar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Sidebar___vue_module_identifier__ = null
var Sidebar_Component = Sidebar_normalizeComponent(
  Sidebar,
  docs_Sidebar,
  Sidebar___vue_template_functional__,
  Sidebar___vue_styles__,
  Sidebar___vue_scopeId__,
  Sidebar___vue_module_identifier__
)

/* harmony default export */ var components_docs_Sidebar = (Sidebar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/Viewer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Viewer = ({
  name: 'docs-viewer',
  props: ['docs', 'darkMode'],
  components: {
    Sidebar: components_docs_Sidebar
  },

  data: function data() {
    return {
      showPrivate: false
    };
  },


  computed: {
    key: function key() {
      var params = this.$route.params;
      if (params.file) return params.category + '/' + params.file;
      if (params.search) return 'search';
      return params.class || params.typedef;
    }
  },

  methods: {
    setShowPrivate: function setShowPrivate(show) {
      this.showPrivate = show;
    },
    scrollTop: function scrollTop() {
      window.scrollTo(0, 0);
    },
    toggleDarkMode: function toggleDarkMode() {
      this.$emit('toggleDarkMode');
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      var scroller = document.getElementById('scroll-top');
      var hideTimeout = void 0;
      var showTimeout = void 0;

      var showListener = function showListener() {
        if ((window.pageYOffset || document.documentElement.scrollTop) > 300) {
          clearTimeout(hideTimeout);
          clearTimeout(showTimeout);
          scroller.style.display = 'block';
          showTimeout = setTimeout(function () {
            scroller.style.opacity = '1';
          }, 20);
          window.removeEventListener('scroll', showListener);
          window.addEventListener('scroll', hideListener);
        }
      };

      var hideListener = function hideListener() {
        if ((window.pageYOffset || document.documentElement.scrollTop) < 300) {
          clearTimeout(hideTimeout);
          clearTimeout(showTimeout);
          scroller.style.opacity = '0';
          hideTimeout = setTimeout(function () {
            scroller.style.display = 'none';
          }, 1000);
          window.removeEventListener('scroll', hideListener);
          window.addEventListener('scroll', showListener);
        }
      };

      window.addEventListener('scroll', showListener);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3fa886e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/Viewer.vue
var Viewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"docs-viewer"}},[_c('container',[_c('sidebar',{attrs:{"docs":_vm.docs,"darkMode":_vm.darkMode},on:{"showPrivate":_vm.setShowPrivate,"toggleDarkMode":_vm.toggleDarkMode}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade-slide","mode":"out-in"}},[_c('router-view',{key:_vm.key,attrs:{"docs":_vm.docs,"showPrivate":_vm.showPrivate,"darkMode":_vm.darkMode}})],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"docs-meta"}},[_c('p',[_vm._v("\n      Documentation built at "+_vm._s(new Date(_vm.docs.meta.date).toUTCString())+"."),_c('br'),_vm._v("\n      Generator: v"+_vm._s(_vm.docs.meta.generator)+"   Format: "+_vm._s(_vm.docs.meta.format)+"\n    ")])]),_vm._v(" "),_c('div',{attrs:{"id":"scroll-top","title":"Scroll to top"},on:{"click":_vm.scrollTop}},[_c('em',{staticClass:"fa fa-arrow-up"})])],1)}
var Viewer_staticRenderFns = []
var Viewer_esExports = { render: Viewer_render, staticRenderFns: Viewer_staticRenderFns }
/* harmony default export */ var docs_Viewer = (Viewer_esExports);
// CONCATENATED MODULE: ./src/components/docs/Viewer.vue
function Viewer_injectStyle (ssrContext) {
  __webpack_require__("809j")
}
var Viewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Viewer___vue_template_functional__ = false
/* styles */
var Viewer___vue_styles__ = Viewer_injectStyle
/* scopeId */
var Viewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Viewer___vue_module_identifier__ = null
var Viewer_Component = Viewer_normalizeComponent(
  Viewer,
  docs_Viewer,
  Viewer___vue_template_functional__,
  Viewer___vue_styles__,
  Viewer___vue_scopeId__,
  Viewer___vue_module_identifier__
)

/* harmony default export */ var components_docs_Viewer = (Viewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/SourceButton.vue
//
//
//
//
//
//
//
//



/* harmony default export */ var SourceButton = ({
  name: 'source-button',
  props: ['meta', 'path', 'docs'],

  methods: {
    sourceURL: function sourceURL(path, file, line) {
      return util_sourceURL(this.docs.source, this.docs.tag, path, file, line);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c86158c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/SourceButton.vue
var SourceButton_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"source-button"},[_c('a',{attrs:{"href":("" + (_vm.meta ? _vm.sourceURL(_vm.meta.path, _vm.meta.file, _vm.meta.line) : _vm.sourceURL(_vm.path))),"title":"Source"}},[_c('em',{staticClass:"fa fa-code"})])])}
var SourceButton_staticRenderFns = []
var SourceButton_esExports = { render: SourceButton_render, staticRenderFns: SourceButton_staticRenderFns }
/* harmony default export */ var docs_SourceButton = (SourceButton_esExports);
// CONCATENATED MODULE: ./src/components/docs/SourceButton.vue
function SourceButton_injectStyle (ssrContext) {
  __webpack_require__("XLOz")
}
var SourceButton_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SourceButton___vue_template_functional__ = false
/* styles */
var SourceButton___vue_styles__ = SourceButton_injectStyle
/* scopeId */
var SourceButton___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SourceButton___vue_module_identifier__ = null
var SourceButton_Component = SourceButton_normalizeComponent(
  SourceButton,
  docs_SourceButton,
  SourceButton___vue_template_functional__,
  SourceButton___vue_styles__,
  SourceButton___vue_scopeId__,
  SourceButton___vue_module_identifier__
)

/* harmony default export */ var components_docs_SourceButton = (SourceButton_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/FileViewer.vue

//
//
//
//
//
//
//
//





/* harmony default export */ var FileViewer = ({
  name: 'file-viewer',
  props: ['docs', 'darkMode'],
  components: {
    SourceButton: components_docs_SourceButton
  },

  data: function data() {
    if (!this.docs.custom[this.$route.params.category]) return { file: null };
    return {
      file: this.docs.custom[this.$route.params.category].files[this.$route.params.file]
    };
  },


  computed: {
    html: function html() {
      var content = void 0;
      if (this.file.type === 'md') content = this.file.content;else content = '# ' + this.file.name + '\n```' + this.file.type + '\n' + this.file.content + '\n```';
      return vue_runtime_esm["a" /* default */].filter('marked')(content);
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(_this.$el.querySelectorAll('pre code')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;
          hljs(el);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88bae688","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/FileViewer.vue
var FileViewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.file)?_c('div',{staticClass:"docs-page",attrs:{"id":"file-viewer"}},[_c('source-button',{attrs:{"path":_vm.file.path,"docs":_vm.docs}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})],1):_c('unknown-page',{staticClass:"docs-page",attrs:{"darkMode":_vm.darkMode}})}
var FileViewer_staticRenderFns = []
var FileViewer_esExports = { render: FileViewer_render, staticRenderFns: FileViewer_staticRenderFns }
/* harmony default export */ var docs_FileViewer = (FileViewer_esExports);
// CONCATENATED MODULE: ./src/components/docs/FileViewer.vue
function FileViewer_injectStyle (ssrContext) {
  __webpack_require__("Veqn")
}
var FileViewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FileViewer___vue_template_functional__ = false
/* styles */
var FileViewer___vue_styles__ = FileViewer_injectStyle
/* scopeId */
var FileViewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FileViewer___vue_module_identifier__ = null
var FileViewer_Component = FileViewer_normalizeComponent(
  FileViewer,
  docs_FileViewer,
  FileViewer___vue_template_functional__,
  FileViewer___vue_styles__,
  FileViewer___vue_scopeId__,
  FileViewer___vue_module_identifier__
)

/* harmony default export */ var components_docs_FileViewer = (FileViewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/TypeLink.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TypeLink = ({
  name: 'type-link',
  props: ['docs', 'type'],
  computed: {
    typeName: function typeName() {
      if (this.type[0] === 'function') return 'Function';
      return this.type[0];
    },
    link: function link() {
      if (this.docs.links[this.type[0]]) return this.docs.links[this.type[0]];
      return null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c369aca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/TypeLink.vue
var TypeLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"docs-type-link"},[(!_vm.link)?_c('span',{attrs:{"title":_vm.type[0] === '*' ? 'Any type' : null}},[_vm._v(_vm._s(_vm.typeName))]):(typeof _vm.link === 'object')?_c('router-link',{attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.typeName))]):_c('a',{attrs:{"href":_vm.link}},[_vm._v(_vm._s(_vm.typeName))]),(_vm.type[1])?_c('span',[_vm._v(_vm._s(_vm.type[1]))]):_vm._e()],1)}
var TypeLink_staticRenderFns = []
var TypeLink_esExports = { render: TypeLink_render, staticRenderFns: TypeLink_staticRenderFns }
/* harmony default export */ var docs_TypeLink = (TypeLink_esExports);
// CONCATENATED MODULE: ./src/components/docs/TypeLink.vue
var TypeLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TypeLink___vue_template_functional__ = false
/* styles */
var TypeLink___vue_styles__ = null
/* scopeId */
var TypeLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TypeLink___vue_module_identifier__ = null
var TypeLink_Component = TypeLink_normalizeComponent(
  TypeLink,
  docs_TypeLink,
  TypeLink___vue_template_functional__,
  TypeLink___vue_styles__,
  TypeLink___vue_scopeId__,
  TypeLink___vue_module_identifier__
)

/* harmony default export */ var components_docs_TypeLink = (TypeLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/Types.vue
//
//
//
//
//
//
//




/* harmony default export */ var Types = ({
  name: 'types',
  props: ['names', 'variable', 'nullable', 'docs'],
  components: {
    TypeLink: components_docs_TypeLink
  },

  methods: {
    typeKey: typeKey
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31b41356","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/Types.vue
var Types_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"docs-type"},[_vm._v("\n  "+_vm._s(_vm.nullable ? '?' : '')+_vm._s(_vm.variable ? '...' : '')),_vm._l((_vm.names),function(type){return _c('type-link',{key:_vm.typeKey(type),attrs:{"type":type,"docs":_vm.docs}})})],2)}
var Types_staticRenderFns = []
var Types_esExports = { render: Types_render, staticRenderFns: Types_staticRenderFns }
/* harmony default export */ var docs_Types = (Types_esExports);
// CONCATENATED MODULE: ./src/components/docs/Types.vue
function Types_injectStyle (ssrContext) {
  __webpack_require__("62bt")
}
var Types_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Types___vue_template_functional__ = false
/* styles */
var Types___vue_styles__ = Types_injectStyle
/* scopeId */
var Types___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Types___vue_module_identifier__ = null
var Types_Component = Types_normalizeComponent(
  Types,
  docs_Types,
  Types___vue_template_functional__,
  Types___vue_styles__,
  Types___vue_scopeId__,
  Types___vue_module_identifier__
)

/* harmony default export */ var components_docs_Types = (Types_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/class-viewer/ParamTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ParamTable = ({
  name: 'param-table',
  props: ['params', 'docs'],
  components: {
    Types: components_docs_Types
  },

  computed: {
    hasOptional: function hasOptional() {
      return this.params.some(function (p) {
        return p.optional;
      });
    }
  },

  methods: {
    typeKey: typeKey,

    paramDescription: function paramDescription(param) {
      return vue_runtime_esm["a" /* default */].filter('marked')(convertLinks(param.description, this.docs, this.$router, this.$route));
    },
    paramDefault: function paramDefault(param) {
      return param.optional ? '<code>' + param.default + '</code>' : '';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eaeb104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/class-viewer/ParamTable.vue
var ParamTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"param-table-wrapper"},[_c('table',{staticClass:"param-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Parameter")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),(_vm.hasOptional)?_c('th',[_vm._v("Optional")]):_vm._e(),_vm._v(" "),(_vm.hasOptional)?_c('th',[_vm._v("Default")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("Description")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.params),function(param){return _c('tr',[_c('td',[_vm._v(_vm._s(param.name))]),_vm._v(" "),_c('td',_vm._l((param.type),function(type){return _c('types',{key:_vm.typeKey(type),attrs:{"names":type,"variable":param.variable,"nullable":param.nullable,"docs":_vm.docs}})}),1),_vm._v(" "),(_vm.hasOptional)?_c('td',[(param.optional)?_c('em',{staticClass:"fa fa-check"}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.hasOptional)?_c('td',[(param.optional && typeof param.default === 'undefined')?_c('em',[_vm._v("none")]):_c('span',{domProps:{"innerHTML":_vm._s(_vm.paramDefault(param))}})]):_vm._e(),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.paramDescription(param))}})])}),0)])])}
var ParamTable_staticRenderFns = []
var ParamTable_esExports = { render: ParamTable_render, staticRenderFns: ParamTable_staticRenderFns }
/* harmony default export */ var class_viewer_ParamTable = (ParamTable_esExports);
// CONCATENATED MODULE: ./src/components/docs/class-viewer/ParamTable.vue
function ParamTable_injectStyle (ssrContext) {
  __webpack_require__("MtcT")
}
var ParamTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ParamTable___vue_template_functional__ = false
/* styles */
var ParamTable___vue_styles__ = ParamTable_injectStyle
/* scopeId */
var ParamTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ParamTable___vue_module_identifier__ = null
var ParamTable_Component = ParamTable_normalizeComponent(
  ParamTable,
  class_viewer_ParamTable,
  ParamTable___vue_template_functional__,
  ParamTable___vue_styles__,
  ParamTable___vue_scopeId__,
  ParamTable___vue_module_identifier__
)

/* harmony default export */ var docs_class_viewer_ParamTable = (ParamTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/class-viewer/Overview.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Overview = ({
  name: 'class-overview',
  props: ['properties', 'methods', 'events'],

  methods: {
    scopedName: scopedName,

    scroll: function scroll(to) {
      var el = document.getElementById('doc-for-' + to);
      el.setAttribute('data-scrolled', true);
      setTimeout(function () {
        return el.setAttribute('data-scrolled', false);
      }, 1000);
      setTimeout(function () {
        return el.removeAttribute('data-scrolled');
      }, 2000);
      el.scrollIntoView();
      window.scrollBy(0, -50);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32168088","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/class-viewer/Overview.vue
var Overview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"class-overview"}},[(_vm.properties && _vm.properties.length > 0)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"title"},[_vm._v("Properties")]),_vm._v(" "),_c('transition-group',{attrs:{"name":"animated-list","tag":"ul"}},_vm._l((_vm.properties),function(property){return _c('li',{key:_vm.scopedName(property),staticClass:"animated-list-item",on:{"click":function($event){_vm.scroll(_vm.scopedName(property))}}},[_c('router-link',{attrs:{"to":{ name: 'docs-class', query: { scrollTo: _vm.scopedName(property) } }}},[_vm._v("\n          "+_vm._s(property.name)+"\n          "),(property.scope === 'static')?_c('span',{staticClass:"small-badge"},[_vm._v("S")]):_vm._e(),_vm._v(" "),(property.abstract)?_c('span',{staticClass:"small-badge"},[_vm._v("A")]):_vm._e(),_vm._v(" "),(property.deprecated)?_c('span',{staticClass:"small-badge warn"},[_vm._v("D")]):_vm._e(),_vm._v(" "),(property.access === 'private')?_c('span',{staticClass:"small-badge warn"},[_vm._v("P")]):_vm._e()])],1)}),0)],1):_vm._e(),_vm._v(" "),(_vm.methods && _vm.methods.length > 0)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"title"},[_vm._v("Methods")]),_vm._v(" "),_c('transition-group',{attrs:{"name":"animated-list","tag":"ul"}},_vm._l((_vm.methods),function(method){return _c('li',{key:_vm.scopedName(method),staticClass:"animated-list-item",on:{"click":function($event){_vm.scroll(_vm.scopedName(method))}}},[_c('router-link',{attrs:{"to":{ name: 'docs-class', query: { scrollTo: _vm.scopedName(method) } }}},[_vm._v("\n          "+_vm._s(method.name)+"\n          "),(method.scope === 'static')?_c('span',{staticClass:"small-badge"},[_vm._v("S")]):_vm._e(),_vm._v(" "),(method.abstract)?_c('span',{staticClass:"small-badge"},[_vm._v("A")]):_vm._e(),_vm._v(" "),(method.deprecated)?_c('span',{staticClass:"small-badge warn"},[_vm._v("D")]):_vm._e(),_vm._v(" "),(method.access === 'private')?_c('span',{staticClass:"small-badge warn"},[_vm._v("P")]):_vm._e()])],1)}),0)],1):_vm._e(),_vm._v(" "),(_vm.events && _vm.events.length > 0)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"title"},[_vm._v("Events")]),_vm._v(" "),_c('ul',_vm._l((_vm.events),function(event){return _c('li',{on:{"click":function($event){return _vm.scroll(("e-" + (event.name)))}}},[_c('router-link',{attrs:{"to":{ name: 'docs-class', query: { scrollTo: ("e-" + (event.name)) } }}},[_vm._v("\n          "+_vm._s(event.name)+"\n          "),(event.deprecated)?_c('span',{staticClass:"small-badge warn"},[_vm._v("D")]):_vm._e()])],1)}),0)]):_vm._e()])}
var Overview_staticRenderFns = []
var Overview_esExports = { render: Overview_render, staticRenderFns: Overview_staticRenderFns }
/* harmony default export */ var class_viewer_Overview = (Overview_esExports);
// CONCATENATED MODULE: ./src/components/docs/class-viewer/Overview.vue
function Overview_injectStyle (ssrContext) {
  __webpack_require__("R4NH")
}
var Overview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Overview___vue_template_functional__ = false
/* styles */
var Overview___vue_styles__ = Overview_injectStyle
/* scopeId */
var Overview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Overview___vue_module_identifier__ = null
var Overview_Component = Overview_normalizeComponent(
  Overview,
  class_viewer_Overview,
  Overview___vue_template_functional__,
  Overview___vue_styles__,
  Overview___vue_scopeId__,
  Overview___vue_module_identifier__
)

/* harmony default export */ var docs_class_viewer_Overview = (Overview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/See.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var See = ({
  name: 'docs-see',
  props: ['see', 'docs'],

  computed: {
    parsed: function parsed() {
      var parsed = new Array(this.see.length);
      for (var s = 0; s < this.see.length; s++) {
        parsed[s] = parseLink(this.see[s], this.docs);
      }return parsed;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-429b6ae6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/See.vue
var See_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"docs-see"},[_vm._v("\n  See also:\n\n  "),(_vm.see.length > 1)?_c('ul',_vm._l((_vm.parsed),function(s){return _c('li',[(typeof s.link === 'object')?_c('router-link',{staticClass:"docs-type",attrs:{"to":s.link}},[_vm._v(_vm._s(s.text))]):(typeof s.link === 'string')?_c('a',{attrs:{"href":s.link}},[_vm._v(_vm._s(s.text))]):_c('span',[_vm._v(_vm._s(s.text))])],1)}),0):_c('span',[(typeof _vm.parsed[0].link === 'object')?_c('router-link',{staticClass:"docs-type",attrs:{"to":_vm.parsed[0].link}},[_vm._v(_vm._s(_vm.parsed[0].text))]):(typeof _vm.parsed[0].link === 'string')?_c('a',{attrs:{"href":_vm.parsed[0].link}},[_vm._v(_vm._s(_vm.parsed[0].text))]):_c('span',[_vm._v(_vm._s(_vm.parsed[0].text))])],1)])}
var See_staticRenderFns = []
var See_esExports = { render: See_render, staticRenderFns: See_staticRenderFns }
/* harmony default export */ var docs_See = (See_esExports);
// CONCATENATED MODULE: ./src/components/docs/See.vue
function See_injectStyle (ssrContext) {
  __webpack_require__("FL5O")
}
var See_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var See___vue_template_functional__ = false
/* styles */
var See___vue_styles__ = See_injectStyle
/* scopeId */
var See___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var See___vue_module_identifier__ = null
var See_Component = See_normalizeComponent(
  See,
  docs_See,
  See___vue_template_functional__,
  See___vue_styles__,
  See___vue_scopeId__,
  See___vue_module_identifier__
)

/* harmony default export */ var components_docs_See = (See_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/class-viewer/Property.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Property = ({
  name: 'class-property',
  props: ['prop', 'docs'],
  components: {
    Types: components_docs_Types,
    ParamTable: docs_class_viewer_ParamTable,
    SourceButton: components_docs_SourceButton,
    See: components_docs_See
  },

  computed: {
    description: function description() {
      return vue_runtime_esm["a" /* default */].filter('marked')(convertLinks(this.prop.description, this.docs, this.$router, this.$route));
    },
    scrollTo: function scrollTo() {
      return '' + (this.prop.scope === 'static' ? 's-' : '') + this.prop.name;
    }
  },

  methods: {
    typeKey: typeKey
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0d2d1c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/class-viewer/Property.vue
var Property_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"class-prop class-item",attrs:{"id":("doc-for-" + _vm.scrollTo)}},[_c('source-button',{attrs:{"meta":_vm.prop.meta,"docs":_vm.docs}}),_vm._v(" "),_c('h3',[_c('router-link',{attrs:{"to":{ name: 'docs-class', query: { scrollTo: _vm.scrollTo } }}},[_vm._v("."+_vm._s(_vm.prop.name))])],1),_vm._v(" "),(_vm.prop.scope === 'static')?_c('span',{staticClass:"badge",attrs:{"title":"This property is on the class constructor function, not instances."}},[_vm._v("Static")]):_vm._e(),_vm._v(" "),(_vm.prop.readonly)?_c('span',{staticClass:"badge",attrs:{"title":"This property cannot be modified."}},[_vm._v("Read-only")]):_vm._e(),_vm._v(" "),(_vm.prop.deprecated)?_c('span',{staticClass:"badge warn",attrs:{"title":"This property is deprecated, and may be removed in a future version."}},[_vm._v("Deprecated")]):_vm._e(),_vm._v(" "),(_vm.prop.access === 'private')?_c('span',{staticClass:"badge warn",attrs:{"title":"This property is private, and may change or be removed at any time."}},[_vm._v("Private")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"class-item-details"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),(_vm.prop.props && _vm.prop.props.length > 0)?_c('param-table',{attrs:{"params":_vm.prop.props,"docs":_vm.docs}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"prop-type"},[_vm._v("\n      Type:\n      "),_vm._l((_vm.prop.type),function(type){return _c('types',{key:_vm.typeKey(type),attrs:{"names":type,"nullable":_vm.prop.nullable,"docs":_vm.docs}})})],2),_vm._v(" "),(_vm.prop.default)?_c('div',{staticClass:"prop-default"},[_vm._v("\n      Default: "),_c('code',[_vm._v(_vm._s(_vm.prop.default))])]):_vm._e(),_vm._v(" "),(_vm.prop.see)?_c('see',{attrs:{"see":_vm.prop.see,"docs":_vm.docs}}):_vm._e()],1)],1)}
var Property_staticRenderFns = []
var Property_esExports = { render: Property_render, staticRenderFns: Property_staticRenderFns }
/* harmony default export */ var class_viewer_Property = (Property_esExports);
// CONCATENATED MODULE: ./src/components/docs/class-viewer/Property.vue
function Property_injectStyle (ssrContext) {
  __webpack_require__("NNCb")
}
var Property_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Property___vue_template_functional__ = false
/* styles */
var Property___vue_styles__ = Property_injectStyle
/* scopeId */
var Property___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Property___vue_module_identifier__ = null
var Property_Component = Property_normalizeComponent(
  Property,
  class_viewer_Property,
  Property___vue_template_functional__,
  Property___vue_styles__,
  Property___vue_scopeId__,
  Property___vue_module_identifier__
)

/* harmony default export */ var docs_class_viewer_Property = (Property_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/class-viewer/Method.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Method = ({
  name: 'class-method',
  props: ['method', 'docs'],
  components: {
    Types: components_docs_Types,
    TypeLink: components_docs_TypeLink,
    ParamTable: docs_class_viewer_ParamTable,
    SourceButton: components_docs_SourceButton,
    See: components_docs_See
  },

  computed: {
    params: function params() {
      if (!this.method.params) return null;
      return this.method.params.filter(function (p) {
        return !p.name.includes('.');
      });
    },
    description: function description() {
      return vue_runtime_esm["a" /* default */].filter('marked')(convertLinks(this.method.description, this.docs, this.$router, this.$route));
    },
    emits: function emits() {
      var _this = this;

      if (!this.method.emits) return null;
      return this.method.emits.map(function (e) {
        return parseLink(e.replace(/:event/i, ''), _this.docs);
      });
    },
    scrollTo: function scrollTo() {
      return '' + (this.method.scope === 'static' ? 's-' : '') + this.method.name;
    }
  },

  methods: {
    typeKey: typeKey
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-928e0af2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/class-viewer/Method.vue
var Method_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"class-method class-item",attrs:{"id":("doc-for-" + _vm.scrollTo)}},[_c('source-button',{attrs:{"meta":_vm.method.meta,"docs":_vm.docs}}),_vm._v(" "),_c('h3',[_c('router-link',{attrs:{"to":{ name: 'docs-class', query: { scrollTo: _vm.scrollTo } }}},[_vm._v("\n\t\t\t\t."+_vm._s(_vm.method.name)+"("),_vm._l((_vm.params),function(param){return _c('span',{staticClass:"method-param",class:param.optional ? 'optional' : ''},[_vm._v(_vm._s(param.variable ? '...' : '')+_vm._s(param.name))])}),_vm._v(")\n\t\t\t")],2)],1),_vm._v(" "),(_vm.method.scope === 'static')?_c('span',{staticClass:"badge",attrs:{"title":"This method is on the class constructor function, not instances."}},[_vm._v("Static")]):_vm._e(),_vm._v(" "),(_vm.method.abstract)?_c('span',{staticClass:"badge",attrs:{"title":"This method is abstract, and must be implemented in a child class."}},[_vm._v("Abstract")]):_vm._e(),_vm._v(" "),(_vm.method.deprecated)?_c('span',{staticClass:"badge warn",attrs:{"title":"This method is deprecated, and may be removed in a future version."}},[_vm._v("Deprecated")]):_vm._e(),_vm._v(" "),(_vm.method.access === 'private')?_c('span',{staticClass:"badge warn",attrs:{"title":"This method is private, and may change or be removed at any time."}},[_vm._v("Private")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"class-item-details"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),(_vm.method.params)?_c('param-table',{attrs:{"params":_vm.method.params,"docs":_vm.docs}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"method-return"},[_vm._v("\n        Returns:\n        "),(_vm.method.returns)?_c('span',_vm._l((_vm.method.returns.types || _vm.method.returns),function(rtrn){return _c('types',{key:_vm.typeKey(rtrn),attrs:{"names":rtrn,"variable":_vm.method.returns.variable,"nullable":_vm.method.returns.nullable,"docs":_vm.docs}})}),1):_c('type-link',{staticClass:"docs-type",attrs:{"type":['void'],"docs":_vm.docs}}),_vm._v(" "),(_vm.method.returns && _vm.method.returns.description)?_c('p',[_vm._v(_vm._s(_vm.method.returns.description))]):_vm._e()],1),_vm._v(" "),(_vm.method.throws)?_c('div',{staticClass:"method-throws"},[_vm._v("\n        Throws:\n        "),_vm._l((_vm.method.throws),function(thrw){return _c('types',{key:thrw,attrs:{"names":thrw,"docs":_vm.docs}})})],2):_vm._e(),_vm._v(" "),(_vm.emits)?_c('div',{staticClass:"method-emits"},[_vm._v("\n        Emits:\n        "),(_vm.emits.length > 1)?_c('ul',_vm._l((_vm.emits),function(event){return _c('li',[_c('router-link',{staticClass:"docs-type",attrs:{"to":event.link}},[_vm._v(_vm._s(event.text))])],1)}),0):_c('router-link',{staticClass:"docs-type",attrs:{"to":_vm.emits[0].link}},[_vm._v(_vm._s(_vm.emits[0].text))])],1):_vm._e(),_vm._v(" "),(_vm.method.examples)?_c('div',{staticClass:"method-examples"},[_vm._v("\n\t\t\t\tExamples:\n\t\t\t\t"),_vm._l((_vm.method.examples),function(example){return _c('pre',[_c('code',{staticClass:"javascript"},[_vm._v(_vm._s(example))])])})],2):_vm._e(),_vm._v(" "),(_vm.method.see)?_c('see',{attrs:{"see":_vm.method.see,"docs":_vm.docs}}):_vm._e()],1)],1)}
var Method_staticRenderFns = []
var Method_esExports = { render: Method_render, staticRenderFns: Method_staticRenderFns }
/* harmony default export */ var class_viewer_Method = (Method_esExports);
// CONCATENATED MODULE: ./src/components/docs/class-viewer/Method.vue
function Method_injectStyle (ssrContext) {
  __webpack_require__("boMg")
}
var Method_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Method___vue_template_functional__ = false
/* styles */
var Method___vue_styles__ = Method_injectStyle
/* scopeId */
var Method___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Method___vue_module_identifier__ = null
var Method_Component = Method_normalizeComponent(
  Method,
  class_viewer_Method,
  Method___vue_template_functional__,
  Method___vue_styles__,
  Method___vue_scopeId__,
  Method___vue_module_identifier__
)

/* harmony default export */ var docs_class_viewer_Method = (Method_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/class-viewer/Event.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Event = ({
  name: 'class-event',
  props: ['event', 'docs'],
  components: {
    ParamTable: docs_class_viewer_ParamTable,
    SourceButton: components_docs_SourceButton,
    See: components_docs_See
  },

  computed: {
    description: function description() {
      return vue_runtime_esm["a" /* default */].filter('marked')(convertLinks(this.event.description, this.docs, this.$router, this.$route));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb5cee22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/class-viewer/Event.vue
var Event_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"class-event class-item",attrs:{"id":("doc-for-e-" + (_vm.event.name))}},[_c('source-button',{attrs:{"meta":_vm.event.meta,"docs":_vm.docs}}),_vm._v(" "),_c('h3',[_c('router-link',{attrs:{"to":{ name: 'docs-class', query: { scrollTo: ("e-" + (_vm.event.name)) } }}},[_vm._v(_vm._s(_vm.event.name))])],1),_vm._v(" "),(_vm.event.deprecated)?_c('span',{staticClass:"badge warn",attrs:{"title":"This event is deprecated, and may be removed in a future version."}},[_vm._v("Deprecated")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"class-item-details"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),(_vm.event.params && _vm.event.params.length > 0)?_c('param-table',{attrs:{"params":_vm.event.params,"docs":_vm.docs}}):_vm._e(),_vm._v(" "),(_vm.event.see)?_c('see',{attrs:{"see":_vm.event.see,"docs":_vm.docs}}):_vm._e()],1)],1)}
var Event_staticRenderFns = []
var Event_esExports = { render: Event_render, staticRenderFns: Event_staticRenderFns }
/* harmony default export */ var class_viewer_Event = (Event_esExports);
// CONCATENATED MODULE: ./src/components/docs/class-viewer/Event.vue
function Event_injectStyle (ssrContext) {
  __webpack_require__("pFWJ")
}
var Event_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Event___vue_template_functional__ = false
/* styles */
var Event___vue_styles__ = Event_injectStyle
/* scopeId */
var Event___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Event___vue_module_identifier__ = null
var Event_Component = Event_normalizeComponent(
  Event,
  class_viewer_Event,
  Event___vue_template_functional__,
  Event___vue_styles__,
  Event___vue_scopeId__,
  Event___vue_module_identifier__
)

/* harmony default export */ var docs_class_viewer_Event = (Event_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/class-viewer/ClassViewer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var ClassViewer = ({
  name: 'class-viewer',
  props: ['docs', 'showPrivate', 'darkMode'],
  components: {
    TypeLink: components_docs_TypeLink,
    ParamTable: docs_class_viewer_ParamTable,
    Overview: docs_class_viewer_Overview,
    Property: docs_class_viewer_Property,
    Method: docs_class_viewer_Method,
    Event: docs_class_viewer_Event,
    SourceButton: components_docs_SourceButton,
    See: components_docs_See
  },

  data: function data() {
    var _this = this;

    return {
      clarse: this.docs.classes.find(function (c) {
        return c.name === _this.$route.params.class;
      })
    };
  },


  computed: {
    constructorParams: function constructorParams() {
      if (!this.clarse.construct || !this.clarse.construct.params) return null;
      return this.clarse.construct.params.filter(function (p) {
        return !p.name.includes('.');
      });
    },
    properties: function properties() {
      if (!this.clarse.props) return null;
      var props = void 0;
      if (this.showPrivate) props = this.clarse.props;else props = this.clarse.props.filter(function (p) {
        return p.access !== 'private';
      });
      return props.sort(function (a, b) {
        return ('' + (a.scope === 'static' ? 'ZZZ' : '') + a.name).localeCompare('' + (b.scope === 'static' ? 'ZZZ' : '') + b.name);
      });
    },
    methods: function methods() {
      if (!this.clarse.methods) return null;
      var methods = void 0;
      if (this.showPrivate) methods = this.clarse.methods;else methods = this.clarse.methods.filter(function (p) {
        return p.access !== 'private';
      });
      return methods.sort(function (a, b) {
        return ('' + (a.scope === 'static' ? 'ZZZ' : '') + a.name).localeCompare('' + (b.scope === 'static' ? 'ZZZ' : '') + b.name);
      });
    },
    description: function description() {
      return vue_runtime_esm["a" /* default */].filter('marked')(convertLinks(this.clarse.description, this.docs, this.$router, this.$route));
    }
  },

  methods: {
    scopedName: scopedName
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(_this2.$el.querySelectorAll('pre code')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;
          hljs(el);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f424bdb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/class-viewer/ClassViewer.vue
var ClassViewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clarse)?_c('div',{staticClass:"docs-page",attrs:{"id":"class-viewer"}},[_c('source-button',{attrs:{"meta":_vm.clarse.meta,"docs":_vm.docs}}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.clarse.name))]),_vm._v(" "),_c('p',{staticClass:"class-name-extra"},[(_vm.clarse.extends)?_c('span',[_vm._v("extends "),_c('type-link',{attrs:{"type":_vm.clarse.extends,"docs":_vm.docs}})],1):_vm._e(),_vm._v(" "),(_vm.clarse.implements)?_c('span',[_vm._v("implements "),_c('type-link',{attrs:{"type":_vm.clarse.implements,"docs":_vm.docs}})],1):_vm._e()]),_vm._v(" "),(_vm.clarse.abstract)?_c('span',{staticClass:"badge class-badge",attrs:{"title":"This class is abstract, and may not be instantiated itself."}},[_vm._v("Abstract")]):_vm._e(),_vm._v(" "),(_vm.clarse.deprecated)?_c('span',{staticClass:"badge class-badge warn",attrs:{"title":"This class is deprecated, and may be removed in a future version."}},[_vm._v("Deprecated")]):_vm._e(),_vm._v(" "),(_vm.clarse.access === 'private')?_c('span',{staticClass:"badge class-badge warn",attrs:{"title":"This class is private, and may change or be removed at any time."}},[_vm._v("Private")]):_vm._e(),_vm._v(" "),(_vm.clarse.description)?_c('p',{staticClass:"class-desc",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),_vm._v(" "),(_vm.clarse.see)?_c('see',{attrs:{"see":_vm.clarse.see,"docs":_vm.docs}}):_vm._e(),_vm._v(" "),(_vm.clarse.construct && (_vm.showPrivate || _vm.clarse.construct.access !== 'private'))?_c('div',{attrs:{"id":"class-constructor"}},[_c('h2',[_vm._v("Constructor")]),_vm._v(" "),_c('pre',[_c('code',{staticClass:"js"},[_vm._v("new "+_vm._s(_vm.docs.global)+"."+_vm._s(_vm.clarse.name)+"("),_vm._l((_vm.constructorParams),function(param){return _c('span',{staticClass:"constructor-param"},[_vm._v(_vm._s(param.name))])}),_vm._v(");")],2)]),_vm._v(" "),_c('param-table',{attrs:{"params":_vm.clarse.construct.params,"docs":_vm.docs}})],1):_vm._e(),_vm._v(" "),_c('overview',{attrs:{"properties":_vm.properties,"methods":_vm.methods,"events":_vm.clarse.events}}),_vm._v(" "),(_vm.properties && _vm.properties.length > 0)?_c('h2',[_vm._v("Properties")]):_vm._e(),_vm._v(" "),_vm._l((_vm.properties),function(prop){return _c('property',{key:_vm.scopedName(prop),attrs:{"prop":prop,"docs":_vm.docs}})}),_vm._v(" "),(_vm.methods && _vm.methods.length > 0)?_c('h2',[_vm._v("Methods")]):_vm._e(),_vm._v(" "),_vm._l((_vm.methods),function(method){return _c('method',{key:_vm.scopedName(method),attrs:{"method":method,"docs":_vm.docs}})}),_vm._v(" "),(_vm.clarse.events && _vm.clarse.events.length > 0)?_c('h2',[_vm._v("Events")]):_vm._e(),_vm._v(" "),_vm._l((_vm.clarse.events),function(event){return _c('event',{key:("e-" + (event.name)),attrs:{"event":event,"docs":_vm.docs}})})],2):_c('unknown-page',{staticClass:"docs-page",attrs:{"darkMode":_vm.darkMode}})}
var ClassViewer_staticRenderFns = []
var ClassViewer_esExports = { render: ClassViewer_render, staticRenderFns: ClassViewer_staticRenderFns }
/* harmony default export */ var class_viewer_ClassViewer = (ClassViewer_esExports);
// CONCATENATED MODULE: ./src/components/docs/class-viewer/ClassViewer.vue
function ClassViewer_injectStyle (ssrContext) {
  __webpack_require__("z09w")
}
var ClassViewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ClassViewer___vue_template_functional__ = false
/* styles */
var ClassViewer___vue_styles__ = ClassViewer_injectStyle
/* scopeId */
var ClassViewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ClassViewer___vue_module_identifier__ = null
var ClassViewer_Component = ClassViewer_normalizeComponent(
  ClassViewer,
  class_viewer_ClassViewer,
  ClassViewer___vue_template_functional__,
  ClassViewer___vue_styles__,
  ClassViewer___vue_scopeId__,
  ClassViewer___vue_module_identifier__
)

/* harmony default export */ var docs_class_viewer_ClassViewer = (ClassViewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/TypedefViewer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var TypedefViewer = ({
  name: 'typedef-viewer',
  props: ['docs', 'darkMode'],
  components: {
    Types: components_docs_Types,
    ParamTable: docs_class_viewer_ParamTable,
    SourceButton: components_docs_SourceButton,
    See: components_docs_See
  },

  data: function data() {
    var _this = this;

    return {
      typedef: this.docs.typedefs.find(function (t) {
        return t.name === _this.$route.params.typedef;
      })
    };
  },


  computed: {
    description: function description() {
      return vue_runtime_esm["a" /* default */].filter('marked')(convertLinks(this.typedef.description, this.docs, this.$router, this.$route));
    },
    returnsDescription: function returnsDescription() {
      var returns = this.typedef.returns;
      if (returns) return vue_runtime_esm["a" /* default */].filter('marked')(convertLinks(returns.description, this.docs, this.$router, this.$route));
      return '';
    }
  },

  methods: {
    typeKey: typeKey
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(_this2.$el.querySelectorAll('pre code')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;
          hljs(el);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2edc85e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/TypedefViewer.vue
var TypedefViewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typedef)?_c('div',{staticClass:"docs-page",attrs:{"id":"typedef-viewer"}},[_c('source-button',{attrs:{"meta":_vm.typedef.meta,"docs":_vm.docs}}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.typedef.name))]),_vm._v(" "),(_vm.typedef.deprecated)?_c('span',{staticClass:"badge warn",attrs:{"title":"This typedef is deprecated, and may be removed in a future version."}},[_vm._v("Deprecated")]):_vm._e(),_vm._v(" "),(_vm.typedef.access === 'private')?_c('span',{staticClass:"badge class-badge warn",attrs:{"title":"This typedef is private, and may change or be removed at any time."}},[_vm._v("Private")]):_vm._e(),_vm._v(" "),(_vm.typedef.description)?_c('p',{staticClass:"typedef-desc",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),_vm._v(" "),(_vm.typedef.see)?_c('see',{attrs:{"see":_vm.typedef.see,"docs":_vm.docs}}):_vm._e(),_vm._v(" "),_c('h2',[_vm._v("Types")]),_vm._v(" "),_c('ul',{attrs:{"id":"typedef-types"}},_vm._l((_vm.typedef.type),function(type){return _c('li',{key:_vm.typeKey(type)},[_c('types',{attrs:{"names":type,"docs":_vm.docs}})],1)}),0),_vm._v(" "),(_vm.typedef.props && _vm.typedef.props.length > 0)?_c('div',{attrs:{"id":"typedef-props"}},[_c('h2',[_vm._v("Properties")]),_vm._v(" "),_c('param-table',{attrs:{"params":_vm.typedef.props,"docs":_vm.docs}})],1):_vm._e(),_vm._v(" "),(_vm.typedef.params && _vm.typedef.params.length > 0)?_c('div',{attrs:{"id":"typedef-params"}},[_c('h2',[_vm._v("Parameters")]),_vm._v(" "),_c('param-table',{attrs:{"params":_vm.typedef.params,"docs":_vm.docs}})],1):_vm._e(),_vm._v(" "),(_vm.typedef.returns)?_c('div',{attrs:{"id":"typedef-returns"}},[_c('h2',[_vm._v("Returns")]),_vm._v(" "),_c('p',{attrs:{"id":"typedef-returns-types"}},_vm._l((_vm.typedef.returns.types || _vm.typedef.returns),function(rtrn){return _c('types',{key:_vm.typeKey(rtrn),attrs:{"names":rtrn,"variable":_vm.typedef.returns.variable,"nullable":_vm.typedef.returns.nullable,"docs":_vm.docs}})}),1),_vm._v(" "),(_vm.typedef.returns.description)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.returnsDescription)}}):_vm._e()]):_vm._e()],1):_c('unknown-page',{staticClass:"docs-page",attrs:{"darkMode":_vm.darkMode}})}
var TypedefViewer_staticRenderFns = []
var TypedefViewer_esExports = { render: TypedefViewer_render, staticRenderFns: TypedefViewer_staticRenderFns }
/* harmony default export */ var docs_TypedefViewer = (TypedefViewer_esExports);
// CONCATENATED MODULE: ./src/components/docs/TypedefViewer.vue
function TypedefViewer_injectStyle (ssrContext) {
  __webpack_require__("rC1B")
}
var TypedefViewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TypedefViewer___vue_template_functional__ = false
/* styles */
var TypedefViewer___vue_styles__ = TypedefViewer_injectStyle
/* scopeId */
var TypedefViewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TypedefViewer___vue_module_identifier__ = null
var TypedefViewer_Component = TypedefViewer_normalizeComponent(
  TypedefViewer,
  docs_TypedefViewer,
  TypedefViewer___vue_template_functional__,
  TypedefViewer___vue_styles__,
  TypedefViewer___vue_scopeId__,
  TypedefViewer___vue_module_identifier__
)

/* harmony default export */ var components_docs_TypedefViewer = (TypedefViewer_Component.exports);

// EXTERNAL MODULE: ./node_modules/fuse.js/dist/fuse.js
var fuse = __webpack_require__("BDm9");
var fuse_default = /*#__PURE__*/__webpack_require__.n(fuse);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/SearchResults.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SearchResults = ({
  props: ['results', 'showScores', 'searchTerm'],

  methods: {
    highlightName: function highlightName(name) {
      return name.replace(this.searchRegex, function (match) {
        return '<strong>' + match + '</strong>';
      });
    }
  },

  computed: {
    searchRegex: function searchRegex() {
      return new RegExp(this.searchTerm, 'ig');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f762fba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/SearchResults.vue
var SearchResults_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"results-list",attrs:{"name":"animated-list","tag":"ul"}},_vm._l((_vm.results),function(result){return _c('li',{key:result.item.key || result.item.fullName || result.item.name,staticClass:"animated-list-item"},[(_vm.showScores)?_c('span',{staticClass:"score"},[_vm._v(_vm._s(Math.round((1 - result.score) * 100))+"%")]):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":result.item.route}},[_c('span',{staticClass:"badge",attrs:{"title":result.item.type}},[_vm._v(_vm._s(result.item.type[0]))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.highlightName(result.item.fullName || result.item.name))}}),_vm._v(_vm._s(result.item.type === 'Method' ? '()' : '')+"\n    ")])],1)}),0)}
var SearchResults_staticRenderFns = []
var SearchResults_esExports = { render: SearchResults_render, staticRenderFns: SearchResults_staticRenderFns }
/* harmony default export */ var docs_SearchResults = (SearchResults_esExports);
// CONCATENATED MODULE: ./src/components/docs/SearchResults.vue
function SearchResults_injectStyle (ssrContext) {
  __webpack_require__("hmEt")
}
var SearchResults_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SearchResults___vue_template_functional__ = false
/* styles */
var SearchResults___vue_styles__ = SearchResults_injectStyle
/* scopeId */
var SearchResults___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchResults___vue_module_identifier__ = null
var SearchResults_Component = SearchResults_normalizeComponent(
  SearchResults,
  docs_SearchResults,
  SearchResults___vue_template_functional__,
  SearchResults___vue_styles__,
  SearchResults___vue_scopeId__,
  SearchResults___vue_module_identifier__
)

/* harmony default export */ var components_docs_SearchResults = (SearchResults_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/Search.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Search = ({
  name: 'docs-search',
  props: ['docs', 'showPrivate'],
  components: {
    SearchResults: components_docs_SearchResults
  },

  data: function data() {
    var toggles = { classes: true, props: true, methods: true, events: true, typedefs: true };
    return {
      toggles: toggles,
      search: this.$route.query.q,
      showScores: false,
      fuse: this.buildFuse(toggles)
    };
  },


  computed: {
    results: function results() {
      var results = this.fuse.search(this.search);

      // Add routes and other necessary info to all results
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var result = _step.value;

          if (result.item.type === 'Class') {
            result.item.route = {
              name: 'docs-class',
              params: { class: result.item.name }
            };
            continue;
          }
          if (result.item.type === 'Property' || result.item.type === 'Method') {
            result.item.fullName = fullName(result.item, result.item.parent);
            result.item.route = {
              name: 'docs-class',
              params: { class: result.item.parent },
              query: { scrollTo: scopedName(result.item) }
            };
            continue;
          }
          if (result.item.type === 'Event') {
            result.item.key = 'e-' + result.item.parent + '#' + result.item.name;
            result.item.fullName = fullName(result.item, result.item.parent);
            result.item.route = {
              name: 'docs-class',
              params: { class: result.item.parent },
              query: { scrollTo: 'e-' + result.item.name }
            };
            continue;
          }
          if (result.item.type === 'Typedef') {
            result.item.route = {
              name: 'docs-typedef',
              params: { typedef: result.item.name }
            };
            continue;
          }
        }

        // Remove class members where the class name is the only place a match is found
        // This avoids listing every member of a class just because the class name matched
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var r = 0;
      while (r < results.length) {
        var _result = results[r];
        if (_result.item.type === 'Property' || _result.item.type === 'Method' || _result.item.type === 'Event') {
          // Get a list of the keys that matched
          var keys = [];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(_result.matches), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var match = _step2.value;
              keys.push(match.key);
            } // Remove the item if only the class name matched
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (keys.length === 2 && keys.includes('parent') && keys.includes('fullName')) {
            results.splice(r, 1);
            continue;
          }
        }
        r++;
      }

      return results;
    },
    fullMatches: function fullMatches() {
      return this.results.filter(function (result) {
        return Math.round((1 - result.score) * 100) === 100;
      });
    },
    partialMatches: function partialMatches() {
      return this.results.filter(function (result) {
        return Math.round((1 - result.score) * 100) !== 100;
      });
    },
    toggleScoresLabel: function toggleScoresLabel() {
      return 'Scores are ' + (this.showScores ? 'shown' : 'hidden') + '. Click to toggle.';
    }
  },

  methods: {
    toggleScores: function toggleScores() {
      this.showScores = !this.showScores;
    },


    // Build an array of all doc items with minimal data
    buildFuse: function buildFuse(toggles) {
      var items = [];

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(this.docs.classes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var c = _step3.value;

          if (!this.showPrivate && c.access === 'private') continue;

          if (toggles.classes) {
            items.push({
              type: 'Class',
              parent: c.name,
              name: c.name,
              fullName: c.name,
              scope: c.scope,
              access: c.access,
              route: null
            });
          }

          if (c.props && toggles.props) {
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = get_iterator_default()(c.props), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var p = _step5.value;

                if (!this.showPrivate && p.access === 'private') continue;
                items.push({
                  type: 'Property',
                  parent: c.name,
                  name: p.name,
                  fullName: fullName(p, c.name),
                  scope: p.scope,
                  access: p.access,
                  route: null
                });
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }
          }

          if (c.methods && toggles.methods) {
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = get_iterator_default()(c.methods), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var m = _step6.value;

                if (!this.showPrivate && m.access === 'private') continue;
                items.push({
                  type: 'Method',
                  parent: c.name,
                  name: m.name,
                  fullName: fullName(m, c.name),
                  scope: m.scope,
                  access: m.access,
                  route: null
                });
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }
          }

          if (c.events && toggles.events) {
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
              for (var _iterator7 = get_iterator_default()(c.events), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var e = _step7.value;

                if (!this.showPrivate && e.access === 'private') continue;
                items.push({
                  type: 'Event',
                  parent: c.name,
                  name: e.name,
                  fullName: c.name + '#' + e.name,
                  scope: e.scope,
                  access: e.access,
                  key: null,
                  route: null
                });
              }
            } catch (err) {
              _didIteratorError7 = true;
              _iteratorError7 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }
              } finally {
                if (_didIteratorError7) {
                  throw _iteratorError7;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (toggles.typedefs) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = get_iterator_default()(this.docs.typedefs), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var t = _step4.value;

            if (!this.showPrivate && t.access === 'private') continue;
            items.push({
              type: 'Typedef',
              parent: t.name,
              name: t.name,
              fullName: t.name,
              scope: t.scope,
              access: t.access,
              route: null
            });
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }

      return new fuse_default.a(items, {
        keys: [{ name: 'name', weight: 0.5 }, { name: 'parent', weight: 0.2 }, { name: 'fullName', weight: 0.3 }],
        shouldSort: true,
        includeScore: true,
        includeMatches: true,
        threshold: 0.4,
        minMatchCharLength: 3
      });
    }
  },

  watch: {
    $route: function $route(to) {
      this.search = to.query.q;
    },
    search: function search(q) {
      if (this.$route.query.q === q) return;
      if (this.$route.query.q) this.$router.replace({ name: 'docs-search', query: { q: q } });else this.$router.push({ name: 'docs-search', query: { q: q } });
    },


    toggles: {
      deep: true,
      handler: function handler() {
        this.fuse = this.buildFuse(this.toggles);
      }
    },

    showPrivate: function showPrivate() {
      this.fuse = this.buildFuse(this.toggles);
    }
  }
});

function fullName(child, parentName) {
  return '' + (parentName + (child.scope === 'static' ? '.' : '#')) + child.name;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09787540","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/Search.vue
var Search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"docs-page",attrs:{"id":"docs-search"}},[_c('em',{class:("fa fa-bar-chart " + (!_vm.showScores ? 'disabled' : '')),attrs:{"id":"show-scores","title":_vm.toggleScoresLabel},on:{"click":_vm.toggleScores}}),_vm._v(" "),_c('h1',[_vm._v("Search")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.search),expression:"search",modifiers:{"trim":true}}],attrs:{"type":"search"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{attrs:{"id":"toggles"}},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggles['classes']),expression:"toggles['classes']"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.toggles['classes'])?_vm._i(_vm.toggles['classes'],null)>-1:(_vm.toggles['classes'])},on:{"change":function($event){var $$a=_vm.toggles['classes'],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.toggles, 'classes', $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.toggles, 'classes', $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.toggles, 'classes', $$c)}}}}),_vm._v(" Classes")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggles['props']),expression:"toggles['props']"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.toggles['props'])?_vm._i(_vm.toggles['props'],null)>-1:(_vm.toggles['props'])},on:{"change":function($event){var $$a=_vm.toggles['props'],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.toggles, 'props', $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.toggles, 'props', $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.toggles, 'props', $$c)}}}}),_vm._v(" Properties")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggles['methods']),expression:"toggles['methods']"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.toggles['methods'])?_vm._i(_vm.toggles['methods'],null)>-1:(_vm.toggles['methods'])},on:{"change":function($event){var $$a=_vm.toggles['methods'],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.toggles, 'methods', $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.toggles, 'methods', $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.toggles, 'methods', $$c)}}}}),_vm._v(" Methods")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggles['events']),expression:"toggles['events']"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.toggles['events'])?_vm._i(_vm.toggles['events'],null)>-1:(_vm.toggles['events'])},on:{"change":function($event){var $$a=_vm.toggles['events'],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.toggles, 'events', $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.toggles, 'events', $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.toggles, 'events', $$c)}}}}),_vm._v(" Events")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggles['typedefs']),expression:"toggles['typedefs']"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.toggles['typedefs'])?_vm._i(_vm.toggles['typedefs'],null)>-1:(_vm.toggles['typedefs'])},on:{"change":function($event){var $$a=_vm.toggles['typedefs'],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.toggles, 'typedefs', $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.toggles, 'typedefs', $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.toggles, 'typedefs', $$c)}}}}),_vm._v(" Typedefs")])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.search && _vm.search.length >= 2)?_c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.results.length)?_c('transition-group',{attrs:{"name":"fade"}},[(_vm.fullMatches.length)?_c('div',{key:"fullMatches",class:{ 'results-separator': _vm.fullMatches.length && _vm.partialMatches.length }},[_c('h2',[_vm._v("Results for \""+_vm._s(_vm.search)+"\"")]),_vm._v(" "),_c('search-results',{attrs:{"results":_vm.fullMatches,"showScores":_vm.showScores,"searchTerm":_vm.search}})],1):_vm._e(),_vm._v(" "),(_vm.partialMatches.length)?_c('div',{key:"partialMatches"},[_c('h2',[_vm._v("Similar results for \""+_vm._s(_vm.search)+"\"")]),_vm._v(" "),_c('search-results',{attrs:{"results":_vm.partialMatches,"showScores":_vm.showScores,"searchTerm":_vm.search}})],1):_vm._e()]):_c('p',[_vm._v("No results.")])],1)],1):_c('p',{key:"short"},[_vm._v("Your search query must be at least two characters.")])])],1)}
var Search_staticRenderFns = []
var Search_esExports = { render: Search_render, staticRenderFns: Search_staticRenderFns }
/* harmony default export */ var docs_Search = (Search_esExports);
// CONCATENATED MODULE: ./src/components/docs/Search.vue
function Search_injectStyle (ssrContext) {
  __webpack_require__("YSnt")
}
var Search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Search___vue_template_functional__ = false
/* styles */
var Search___vue_styles__ = Search_injectStyle
/* scopeId */
var Search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Search___vue_module_identifier__ = null
var Search_Component = Search_normalizeComponent(
  Search,
  docs_Search,
  Search___vue_template_functional__,
  Search___vue_styles__,
  Search___vue_scopeId__,
  Search___vue_module_identifier__
)

/* harmony default export */ var components_docs_Search = (Search_Component.exports);

// CONCATENATED MODULE: ./src/router.js












vue_runtime_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var src_router = (new vue_router_esm["a" /* default */]({
  routes: [{ path: '/', name: 'home', component: components_pages_Home }, { path: '/docs', name: 'docs', component: components_pages_Documentation, children: [{ path: ':source', name: 'docs-source', component: components_docs_Loader, children: [{ path: ':tag', name: 'docs-tag', component: components_docs_Viewer, children: [{ path: 'search', name: 'docs-search', component: components_docs_Search }, { path: 'class/:class', name: 'docs-class', component: docs_class_viewer_ClassViewer }, { path: 'typedef/:typedef', name: 'docs-typedef', component: components_docs_TypedefViewer }, { path: ':category/:file', name: 'docs-file', component: components_docs_FileViewer }] }] }] },

  // Old URLs
  { path: '/!', redirect: { name: 'home' }, children: [{ path: 'docs', redirect: { name: 'docs' }, children: [{ path: 'tag/:tag', redirect: function redirect(to) {
          return {
            name: 'docs-tag',
            params: { source: 'main', tag: to.params.tag },
            query: { scrollTo: to.query.scrollto }
          };
        },
        children: [{ path: 'file/:category/:file', redirect: function redirect(to) {
            return {
              name: 'docs-file',
              params: { source: 'main', tag: to.params.tag, category: to.params.category, file: to.params.file },
              query: { scrollTo: to.query.scrollto }
            };
          }
        }, { path: 'class/:class', redirect: function redirect(to) {
            return {
              name: 'docs-class',
              params: { source: 'main', tag: to.params.tag, class: to.params.class },
              query: { scrollTo: to.query.scrollto }
            };
          }
        }, { path: 'typedef/:typedef', redirect: function redirect(to) {
            return {
              name: 'docs-typedef',
              params: { source: 'main', tag: to.params.tag, typedef: to.params.typedef },
              query: { scrollTo: to.query.scrollto }
            };
          }
        }] }] }] },

  // Catch-all
  { path: '*', component: components_pages_UnknownRoute }]
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Container.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Container = ({ name: 'container' });
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13aaf031","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Container.vue
var Container_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_vm._t("default")],2)}
var Container_staticRenderFns = []
var Container_esExports = { render: Container_render, staticRenderFns: Container_staticRenderFns }
/* harmony default export */ var components_Container = (Container_esExports);
// CONCATENATED MODULE: ./src/components/Container.vue
function Container_injectStyle (ssrContext) {
  __webpack_require__("Iyms")
}
var Container_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Container___vue_template_functional__ = false
/* styles */
var Container___vue_styles__ = Container_injectStyle
/* scopeId */
var Container___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Container___vue_module_identifier__ = null
var Container_Component = Container_normalizeComponent(
  Container,
  components_Container,
  Container___vue_template_functional__,
  Container___vue_styles__,
  Container___vue_scopeId__,
  Container___vue_module_identifier__
)

/* harmony default export */ var src_components_Container = (Container_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Slide.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var Slide = ({ name: 'slide' });
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-222c5578","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slide.vue
var Slide_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide"},[_c('container',[_vm._t("default")],2)],1)}
var Slide_staticRenderFns = []
var Slide_esExports = { render: Slide_render, staticRenderFns: Slide_staticRenderFns }
/* harmony default export */ var components_Slide = (Slide_esExports);
// CONCATENATED MODULE: ./src/components/Slide.vue
function Slide_injectStyle (ssrContext) {
  __webpack_require__("tzlZ")
}
var Slide_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Slide___vue_template_functional__ = false
/* styles */
var Slide___vue_styles__ = Slide_injectStyle
/* scopeId */
var Slide___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Slide___vue_module_identifier__ = null
var Slide_Component = Slide_normalizeComponent(
  Slide,
  components_Slide,
  Slide___vue_template_functional__,
  Slide___vue_styles__,
  Slide___vue_scopeId__,
  Slide___vue_module_identifier__
)

/* harmony default export */ var src_components_Slide = (Slide_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Loading.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Loading = ({ name: 'loading' });
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19919b67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
var Loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Loading_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-folding-cube"},[_c('div',{staticClass:"sk-cube1 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube2 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube4 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube3 sk-cube"})])}]
var Loading_esExports = { render: Loading_render, staticRenderFns: Loading_staticRenderFns }
/* harmony default export */ var components_Loading = (Loading_esExports);
// CONCATENATED MODULE: ./src/components/Loading.vue
function Loading_injectStyle (ssrContext) {
  __webpack_require__("XnjJ")
}
var Loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Loading___vue_template_functional__ = false
/* styles */
var Loading___vue_styles__ = Loading_injectStyle
/* scopeId */
var Loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Loading___vue_module_identifier__ = null
var Loading_Component = Loading_normalizeComponent(
  Loading,
  components_Loading,
  Loading___vue_template_functional__,
  Loading___vue_styles__,
  Loading___vue_scopeId__,
  Loading___vue_module_identifier__
)

/* harmony default export */ var src_components_Loading = (Loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Awesome.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var Awesome = ({
  name: 'awesome',
  props: ['light']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08b126bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Awesome.vue
var Awesome_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"432.4","height":"567.1","version":"1.1","viewBox":"0 0 114.4 150.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"transform":"translate(58.39 -90.57)","fill":_vm.light ? 'white' : 'black'}},[_c('path',{attrs:{"d":"m36.98 239.8c-0.701-1.163-1.164-2.237-2.31-5.358-0.5341-1.455-1.264-3.301-1.623-4.101-0.3584-0.8004-1.071-2.408-1.584-3.572-1.048-2.38-1.192-2.7-3.641-8.129-0.9667-2.143-2.005-4.703-2.308-5.689-0.6518-2.124-1.094-3.146-3.167-7.312-0.8587-1.726-1.561-3.302-1.561-3.502v-0.3641l-27.38 0.3366-0.191 0.2908c-0.105 0.1599-0.4353 1.092-0.7338 2.072-0.2986 0.9798-0.7809 2.185-1.072 2.678s-0.6905 1.478-0.8878 2.187-0.6848 2.184-1.083 3.275c-1.182 3.236-1.708 5.263-2.123 8.182l-0.3918 2.758-4e-3 3.327-4e-3 3.327-0.3608 1.534c-0.1985 0.8434-0.4296 1.602-0.5136 1.686l-0.1528 0.1528-0.7993-0.3067 0.8625-2.008 0.4067-10.05 0.2774-1.72c0.3197-1.982 0.976-4.316 2.009-7.144 0.3987-1.091 0.8862-2.565 1.083-3.275s0.5939-1.689 0.8815-2.177c0.4808-0.8148 1.606-4.066 1.606-4.64v-0.246l-1.042 0.5576-12.32-0.142 0.04-0.5292c0.022-0.291 0.2165-1.392 0.4322-2.447l0.3921-1.918 0.385-0.596c0.2118-0.3278 0.6039-1.191 0.8714-1.919l0.4864-1.323 2.818-2.802 0.5285-1.036c0.2907-0.5698 0.5285-1.269 0.5285-1.554 0-0.2848 0.2382-1.073 0.5294-1.753l0.5293-1.235 0.1579-2.293 0.1578-2.293 0.5182-2.514c0.285-1.382 0.5806-2.811 0.6569-3.175 0.0763-0.3638 0.4432-1.651 0.8153-2.86l0.6765-2.199-0.8962-0.9331c-0.4929-0.5132-1.313-1.162-1.822-1.442-0.5093-0.2801-1.64-1.103-2.514-1.829-0.8731-0.7256-2.958-2.255-4.633-3.399s-3.216-2.285-3.424-2.536-0.9213-0.8258-1.585-1.277c-0.6632-0.4516-1.958-1.455-2.878-2.229-0.9194-0.7745-2.051-1.604-2.514-1.843-0.9062-0.4684-2.179-1.441-4.119-3.147-0.6715-0.5906-1.876-1.536-2.676-2.101-1.693-1.195-2.7-2.088-8.046-7.128-6.046-5.7-10.86-10.61-12.03-12.27l-0.6213-0.8803 0.5074-0.5074 1.606 1.928c1.585 1.902 5.771 6.111 11.71 11.77 4.193 3.998 5.381 5.047 7.673 6.778 1.091 0.8241 2.639 2.043 3.44 2.708 0.8004 0.6654 2.096 1.627 2.88 2.137 1.306 0.8499 3.627 2.641 7.042 5.434 0.7276 0.5951 2.514 1.896 3.969 2.891s3.301 2.345 4.101 2.999c0.8004 0.6545 1.812 1.385 2.249 1.623 0.4366 0.2384 1.228 0.8496 1.759 1.358l0.9656 0.9246 0.1883-0.623c0.1036-0.3426 0.3401-0.9802 0.5257-1.417 0.1855-0.4366 0.5776-1.449 0.8714-2.249 2.052-5.593 3.5-8.935 4.411-10.19 0.3179-0.4366 0.6577-1.01 0.7551-1.274l0.1771-0.4798 0.2664 0.1647c0.3759 0.2323 0.3308 0.9427-0.0911 1.436-0.7629 0.8912-2.955 5.537-3.827 8.11-0.6586 1.943-1.306 3.67-1.784 4.755-0.1951 0.4432-0.4837 1.382-0.6414 2.085-0.1577 0.7037-0.5273 1.994-0.8214 2.867-0.2941 0.8729-0.6433 2.078-0.7761 2.677-0.1328 0.5995-0.4268 1.923-0.6535 2.942-0.2267 1.019-0.5275 3.144-0.6684 4.723l-0.2563 2.871-0.5542 1.76c-0.3048 0.9678-0.8586 2.39-1.231 3.16l-0.6763 1.4-1.285 1.231c-0.7066 0.6772-1.285 1.332-1.285 1.455s-0.3737 1.023-0.8304 1.999l-0.8304 1.775-0.3603 1.72c-0.1982 0.9458-0.3603 1.75-0.3603 1.786 0 0.0364 2.508 0.0662 5.574 0.0662h5.574l0.8913-0.4757 21.96-0.1639c12.08-0.0902 23.42-0.2332 25.2-0.318l3.241-0.1541v-0.9676l-1.002-1.54c-0.9603-1.477-2.438-4.775-2.438-5.441 0-0.6229-1.427-4.049-2.032-4.878-0.3378-0.4632-0.6142-0.904-0.6142-0.9795s-0.5228-0.8871-1.162-1.804c-0.6389-0.9165-1.49-2.262-1.891-2.989-0.4012-0.7276-1.173-1.859-1.716-2.514-0.5426-0.6548-1.671-2.322-2.507-3.704s-1.982-3.174-2.546-3.98c-0.5644-0.8067-1.026-1.565-1.026-1.685 0-0.12-0.3274-0.6109-0.7276-1.091-0.6424-0.7705-1.055-1.375-2.712-3.975-0.2183-0.3425-1.087-1.152-1.93-1.798l-1.533-1.176-1.087-1.548c-0.5978-0.8516-1.412-1.905-1.809-2.342-0.9476-1.042-1.315-1.788-1.315-2.674v-0.7242l0.4201-0.4642 0.4201-0.4642-0.1786-0.8078-1.275 0.6488c-0.701 0.3568-1.449 0.6488-1.663 0.6488-0.2136 0-0.683 0.193-1.043 0.429l-0.6547 0.429-8.065-0.2761-1.296-0.4224c-1.294-0.4218-4.012-1.846-5.559-2.913-1.841-1.27-4.884-4.663-7.952-8.867-1.322-1.811-1.513-2.153-4.097-7.341l-2.13-4.277v-4.45l0.6839-1.964c0.3762-1.08 1.343-3.63 2.148-5.666l1.464-3.701 1.064-1.855c1.548-2.699 1.775-3.142 1.662-3.255-0.0559-0.0559-0.6431 0.2158-1.305 0.6037l-1.203 0.7053-0.2725-0.1684c-0.1499-0.0926-0.2725-0.2787-0.2725-0.4136v-0.2452l1.521-0.8114c0.8367-0.4463 2.209-1.183 3.05-1.637l1.529-0.8255-0.5438-0.5438v-1.715l0.4831-0.2986 0.1852-1.096c0.2746-1.625 0.8354-2.801 2.152-4.513l1.181-1.535 1.637-1.123c2.127-1.458 2.25-1.529 5.209-2.99 3.923-1.938 5.041-2.391 6.747-2.737l1.588-0.3223 5.778 0.1638 0.2194 0.6615h-6.387l-1.261 0.3039c-1.365 0.329-2.124 0.6261-4.965 1.944-1.019 0.4724-2.031 0.9352-2.249 1.028-0.2183 0.0932-0.7541 0.4049-1.191 0.6928-0.4366 0.2878-0.9711 0.6079-1.188 0.7112-0.2168 0.1033-1.019 0.6254-1.782 1.16l-1.388 0.9723-1.061 1.284c-1.224 1.482-1.967 2.963-2.241 4.471-0.1058 0.5821-0.3093 1.2-0.4523 1.373l-0.26 0.3147 0.1706 1.37 2.117-1.115 5.121 0.3278 1.931-3.295 5.489-5.59 3.387-1.72h2.619l0.2514 0.2331c0.318 0.2949 4.506 1.726 6.606 2.257 0.8759 0.2216 3.495 0.713 5.821 1.092l4.228 0.689 0.4939 0.4824-0.1744 0.1744-0.1744 0.1744-2.983-0.4506c-1.641-0.2478-4.173-0.6896-5.627-0.9818l-2.644-0.5312-2.78-0.9333c-1.529-0.5133-2.893-1.041-3.032-1.173l-0.2514-0.2393h-2.09l-3.409 1.72-5.07 5.29-0.7482 1.269c-0.4115 0.698-0.7482 1.306-0.7482 1.351 0 0.0454 0.8791 0.1489 1.954 0.2302l1.954 0.1478 0.807 0.4173c0.4439 0.2295 1.501 1.06 2.349 1.845l1.542 1.427 3.17-3.162 1.014-0.5217c0.5575-0.287 1.927-0.7622 3.043-1.056l2.029-0.5344 6.937-0.2937 1.162 0.4301c0.6389 0.2365 2.293 0.6714 3.675 0.9664s2.752 0.6388 3.043 0.764 1.303 0.3706 2.249 0.5452c0.9459 0.1746 1.831 0.4255 1.967 0.5574l0.247 0.2398-0.3588 0.3588-1.92-0.3336c-1.056-0.1835-2.158-0.4381-2.449-0.5659-0.291-0.1278-1.87-0.5295-3.51-0.8927s-3.209-0.7826-3.488-0.932l-0.5076-0.2717h-4.728l-2.268 0.3956c-2.154 0.3756-2.628 0.5162-4.583 1.359l-0.8287 0.3573-3.39 3.373 2.207 2.857 1.308 2.51c0.7192 1.38 1.447 2.748 1.616 3.039 0.5083 0.8714 1.651 4.099 2.201 6.218 0.2835 1.091 0.6187 2.342 0.7448 2.778 0.1261 0.4366 0.6651 2.461 1.198 4.498l0.9684 3.704-0.2342 10.58-0.3813 0.9872c-0.2097 0.543-0.4629 1.069-0.5626 1.169-0.0997 0.0997-0.1813 0.3754-0.1813 0.6127v0.4314l-2.117 2.067v1.892l-0.8439 1.205 0.1504 0.5994 0.1504 0.5994 0.8668 0.942c0.4768 0.5181 1.317 1.609 1.867 2.424l0.9997 1.482 3.689 2.944v0.3446c0 0.4518 0.8596 1.22 1.365 1.22h0.3973l3.769-3.307 1.587-1.914c0.8728-1.053 2.099-2.644 2.724-3.536 0.6256-0.8921 1.614-2.303 2.196-3.136 1.387-1.984 3.137-4.171 6.226-7.782 1.387-1.621 2.809-3.364 3.16-3.874 0.3514-0.5093 1.13-1.521 1.729-2.249 1.449-1.759 5.121-6.978 5.95-8.459 0.3638-0.6493 1.125-1.988 1.691-2.975 0.5664-0.9872 1.234-2.367 1.483-3.065l0.4528-1.27 0.4744-0.105 0.171 1.205-0.9593 1.942c-0.5276 1.068-1.37 2.579-1.871 3.357-0.5017 0.7786-0.9121 1.522-0.9121 1.651 0 0.1296-0.4465 0.8078-0.9922 1.507-0.5457 0.6994-1.468 1.954-2.051 2.788s-1.571 2.184-2.198 3c-0.627 0.8156-1.52 2.007-1.984 2.647-0.4644 0.6404-2.035 2.563-3.49 4.273-4.236 4.977-5.58 6.723-8.442 10.97-1.358 2.014-4.155 5.462-5.023 6.193-0.2754 0.2319-1.072 0.9176-1.77 1.524-0.698 0.6063-1.467 1.213-1.71 1.349l-0.4406 0.2466 0.3974 0.7684c0.2186 0.4226 0.6477 0.995 0.9536 1.272s0.5563 0.6286 0.5563 0.7816c0 0.153 0.4618 0.9382 1.026 1.745 0.5644 0.8067 1.71 2.598 2.546 3.98s1.964 3.049 2.507 3.704c0.5426 0.6548 1.315 1.786 1.716 2.514 0.4012 0.7276 1.252 2.073 1.891 2.989 0.6389 0.9165 1.162 1.728 1.162 1.804s0.2764 0.5163 0.6142 0.9795c0.6047 0.8291 2.032 4.256 2.032 4.878 0 0.6707 1.48 3.969 2.452 5.462l1.015 1.561-0.1596 1.906-1.984 0.1639c-1.091 0.0901-5.884 0.1794-10.65 0.1984l-8.665 0.0346v0.2358c0 0.1297 0.7026 1.648 1.561 3.373 2.059 4.139 2.516 5.189 3.146 7.239 0.4673 1.52 1.519 4.024 3.501 8.334 0.3345 0.7276 0.8172 1.799 1.073 2.381 1.202 2.739 2.387 5.422 2.981 6.747 0.3584 0.8004 1.086 2.646 1.617 4.101s1.346 3.414 1.812 4.354 0.8865 1.803 0.935 1.918l0.0882 0.2102h-0.7947zm-26.19-85.76c0.4779-0.202 1.494-0.6393 2.259-0.9718l1.39-0.6044-0.1344-0.8346h1.152l1.626-1.554v-0.4268c0-0.2347 0.0984-0.5399 0.2186-0.6781 0.1202-0.1382 0.3881-0.7871 0.5953-1.442l0.3767-1.191-0.01-5.292-0.01-5.292-0.4248-1.588c-0.2336-0.8731-0.7429-2.719-1.132-4.101-0.3888-1.382-0.9261-3.347-1.194-4.366-0.5314-2.02-1.683-5.245-2.173-6.085-0.1698-0.291-0.893-1.651-1.607-3.021-1.317-2.527-2.839-4.743-3.524-5.128l-0.3762-0.2116v-0.7184l-1.372-1.234c-0.7549-0.6787-1.735-1.422-2.179-1.651l-0.8064-0.417-9.543-0.4566-0.9211 0.4714c-0.5066 0.2593-1.49 0.8641-2.186 1.344l-1.265 0.8725-0.6127 1.238c-0.337 0.6811-1.093 2.073-1.68 3.093l-1.067 1.855-1.464 3.702c-0.8053 2.036-1.772 4.585-2.148 5.666l-0.6839 1.964v3.921l2.183 4.397c1.201 2.418 2.361 4.71 2.58 5.093 1.027 1.802 5.283 7.157 6.983 8.786 1.591 1.525 2.33 2.048 4.659 3.299l1.984 1.066 1.191 0.2905c2.035 0.4965 2.17 0.5101 5.349 0.5416l3.1 0.0307zm-11.43-10.07c-0.1765-0.2126-0.578-0.4671-0.8923-0.5654-0.3143-0.0983-1.069-0.5197-1.677-0.9363-0.6083-0.4166-1.192-0.7575-1.298-0.7575-0.1056 0-0.5778-0.2943-1.049-0.654l-0.8575-0.654-0.8486-2.49v-1.696l-1.112-0.2907 0.1745-0.2824 0.1745-0.2824h6.552l0.2761 0.4467 7.521 0.359 0.7012 0.582v1.523h-0.4814l-0.6105 3.619-1.036 1.704-1.824 0.7619h-3.392zm4.083-0.7832 0.9-0.376 0.4069-0.7868c0.2238-0.4328 0.4846-1.305 0.5796-1.939 0.095-0.6337 0.3521-1.543 0.5714-2.022s0.3492-0.9189 0.2886-0.9795c-0.0606-0.0606-1.713-0.1844-3.673-0.2752l-3.563-0.1651-1.069-0.5134-4.222 0.1568-0.0791 0.68-0.0791 0.68 0.952 2.533 1.191 0.6644c0.6548 0.3654 1.496 0.8805 1.868 1.145 0.3727 0.2642 1.007 0.5631 1.41 0.6642l0.7328 0.1839 0.2785 0.7256h2.606zm-13.18-12.5-0.1764-0.1764v-12.05l0.5753-0.3555 0.3508 0.4566-0.1512 12.3h-0.211c-0.116 0-0.2904-0.0794-0.3874-0.1764zm12.37-5.728c-0.0736-0.1917-0.0996-1.591-0.0578-3.109l0.0759-2.76h0.5292l0.149 6.218h-0.2813c-0.1547 0-0.3415-0.1569-0.4151-0.3486z","stroke-width":".2646"}})])])}
var Awesome_staticRenderFns = []
var Awesome_esExports = { render: Awesome_render, staticRenderFns: Awesome_staticRenderFns }
/* harmony default export */ var components_Awesome = (Awesome_esExports);
// CONCATENATED MODULE: ./src/components/Awesome.vue
var Awesome_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Awesome___vue_template_functional__ = false
/* styles */
var Awesome___vue_styles__ = null
/* scopeId */
var Awesome___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Awesome___vue_module_identifier__ = null
var Awesome_Component = Awesome_normalizeComponent(
  Awesome,
  components_Awesome,
  Awesome___vue_template_functional__,
  Awesome___vue_styles__,
  Awesome___vue_scopeId__,
  Awesome___vue_module_identifier__
)

/* harmony default export */ var src_components_Awesome = (Awesome_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UnknownPage.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UnknownPage = ({
  name: 'unknown-page',
  props: ['type', 'darkMode'],
  components: { Awesome: src_components_Awesome }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31ea7a7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UnknownPage.vue
var UnknownPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Unknown "+_vm._s(_vm.type || 'page'))]),_vm._v(" "),_c('p',[_vm._v("This page doesn't actually exist. Oh no!")]),_vm._v(" "),_c('p',[_vm._v("Instead, please accept this exceptionally awesome piece of artwork:")]),_vm._v(" "),_c('p',[_c('awesome',{attrs:{"light":_vm.darkMode}})],1)])}
var UnknownPage_staticRenderFns = []
var UnknownPage_esExports = { render: UnknownPage_render, staticRenderFns: UnknownPage_staticRenderFns }
/* harmony default export */ var components_UnknownPage = (UnknownPage_esExports);
// CONCATENATED MODULE: ./src/components/UnknownPage.vue
function UnknownPage_injectStyle (ssrContext) {
  __webpack_require__("e2ri")
}
var UnknownPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UnknownPage___vue_template_functional__ = false
/* styles */
var UnknownPage___vue_styles__ = UnknownPage_injectStyle
/* scopeId */
var UnknownPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UnknownPage___vue_module_identifier__ = null
var UnknownPage_Component = UnknownPage_normalizeComponent(
  UnknownPage,
  components_UnknownPage,
  UnknownPage___vue_template_functional__,
  UnknownPage___vue_styles__,
  UnknownPage___vue_scopeId__,
  UnknownPage___vue_module_identifier__
)

/* harmony default export */ var src_components_UnknownPage = (UnknownPage_Component.exports);

// CONCATENATED MODULE: ./src/main.js











vue_runtime_esm["a" /* default */].config.productionTip = false;

__webpack_require__("srIy");

// Register global components
vue_runtime_esm["a" /* default */].component('container', src_components_Container);
vue_runtime_esm["a" /* default */].component('slide', src_components_Slide);
vue_runtime_esm["a" /* default */].component('loading', src_components_Loading);
vue_runtime_esm["a" /* default */].component('unknown-page', src_components_UnknownPage);

// Register the hightlight.js directive
vue_runtime_esm["a" /* default */].directive('hljs', hljs);

// Register filters
vue_runtime_esm["a" /* default */].filter('marked', function (text) {
  if (!text) text = '**Documentation missing.**';
  text = text.replace(/<(info|warn)>([\s\S]+)<\/\1>/gi, '<div class="$1">$2</div>');
  return marked_default()(text);
});

/* eslint-disable no-new */
new vue_runtime_esm["a" /* default */]({
  el: '#app',
  router: src_router,
  render: function render(h) {
    return h(src_App);
  }
});

/***/ }),

/***/ "NNCb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R4NH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Veqn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XLOz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XV0z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XnjJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YSnt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZDZm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "boMg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e2ri":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hmEt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pFWJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rC1B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "srIy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t5H2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tzlZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z09w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zMz9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f9f25c77a6c3f2ab449c.js